import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import _, { cloneDeep as _cloneDeep, find as _find, forEach as _forEach, findIndex as _findIndex } from 'lodash';
import { Button, ButtonGroup, Dropdown, ProgressBar } from 'react-bootstrap';
import { Tooltip } from 'react-tooltip';
import { confirmAlert } from 'js/wrapper/CustomConfirmAlert';
import { TourProvider, useTour } from '@reactour/tour';
import { getNameInCurrentLanguage } from 'helpers/intl';
import Axios from 'axios';
import { Beforeunload } from 'react-beforeunload';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { connect } from 'react-redux';
import { S3_DOMAIN, S3_LINKS, FILTERS } from 'js/constants';
import FormInputConfirm from 'components/forms/FormInputConfirm';
import { addNotification } from 'actions/NotificationsActions';
import EditorSettingsContext from 'cc-editor/EditorSettingsContext';
import { blockForm, releaseForm } from 'actions/ActiveFormsActions';
import { toast, Toaster } from 'sonner';
import withRouter from '../withRouter';
import EditorToolbarFTs from './components/EditorToolbarFTs';
import EditorApplyStylesFTs from './components/EditorApplyStylesFTs';
import EditorCanvasFTs from './components/EditorCanvasFTs';
import { getBlockTopFromRaster } from './components/actions/Raster';
import { changeBlock, copyBlock, createTimelineBlockEntry, getBlockResizers, insertBlock, pasteBlock, removeBlock, resetBlock, resizeBlock, } from './components/actions/Blocks';
import { getPageNameIndex } from './components/actions/TemplateSettings';
import PreviewBlockFTs from './components/PreviewBlockFTs';
import { tourSteps } from './helpers/tour';
import { checkIfMediaBlockExists, checkIfMediaIsUnused, checkIfMediaStaysSame } from './components/actions/UsedMedia';
import may from '../security';
import ActiveFormsToolbar from '../components/forms/ActiveFormsToolbar';
import { getDeviceType } from './components/actions/deviceType';
/**
 * Extracts attribute value from a HTML code string
 */
const getNumericValue = (str, attributeName) => {
    const re = new RegExp(`${attributeName}="\\s*([^"\\s]*)`);
    const match = re.exec(str);
    return match ? Number(match[1]) : 0;
};
function TourTrigger({ showTour }) {
    const { setIsOpen } = useTour();
    React.useEffect(() => {
        setIsOpen(showTour);
    }, [showTour, setIsOpen]);
    return null;
}
const EditorFTs = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const { edition, setVariables, appIntl, doBlockForm, user, doReleaseForm, unsavedR, linkDataR, history, forwardingR, setUnsaved, showErrorMessage, waitForSaving, changesR, setChangesR, savingR, save_ContentR: saveContentR, saveToR, initTemplateR, getCampaignsR, campaignOptionsR, printingR, previewingR, accessibleR, printx, exportingR, doNotify, activeForms, globalCss, intl, showTourInit, projectConfig, } = props;
    const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : intl === null || intl === void 0 ? void 0 : intl.messages;
    // Refs
    const _isMounted = useRef(true);
    const fontCheckRef = useRef(undefined);
    const autoSaveRef = useRef(undefined);
    const waitForSavingRef = useRef(undefined);
    const virtualKeyboardHandlerRef = useRef(null);
    // Initial state setup
    const [state, setState] = useState(() => {
        const contentPages = _cloneDeep(edition.pages);
        const templateBlocks = edition.template.template_block_category;
        const savedBlocks = [];
        _.forEach(contentPages, (contentPage, i) => {
            _.forEach(contentPage.blocks, (block, j) => {
                savedBlocks.push({
                    id: block.id,
                    i,
                    j,
                    template_id: block.template_id,
                    top: block.top,
                    params: block.params,
                    errors: block.errors,
                    blocks: block.blocks,
                    space_consumed: block.space_consumed,
                    position_x: block.position_x,
                    position_y: block.position_y,
                });
            });
        });
        _.forEach(templateBlocks, (category) => {
            _.forEach(category.variants, (variant) => {
                _.forEach(variant.blocks, (templateBlock) => {
                    _.forEach(savedBlocks, (block) => {
                        if (block.blocks) {
                            _.forEach(block.blocks, (innerBlock, n) => {
                                if (innerBlock.template_id === templateBlock.id) {
                                    const newInnerBlock = _.cloneDeep(templateBlock);
                                    newInnerBlock.id = innerBlock.id;
                                    newInnerBlock.template_id = innerBlock.template_id;
                                    newInnerBlock.top = innerBlock.top;
                                    newInnerBlock.params = innerBlock.params;
                                    newInnerBlock.errors = innerBlock.errors;
                                    newInnerBlock.position_x = innerBlock.position_x;
                                    newInnerBlock.position_y = innerBlock.position_y;
                                    block.blocks[n] = newInnerBlock;
                                }
                            });
                        }
                        if (block.template_id === templateBlock.id) {
                            const newBlock = _.cloneDeep(templateBlock);
                            newBlock.id = block.id;
                            newBlock.template_id = block.template_id;
                            newBlock.top = block.top;
                            newBlock.params = block.params;
                            newBlock.errors = block.errors;
                            newBlock.blocks = block.blocks;
                            newBlock.space_consumed = block.space_consumed;
                            newBlock.position_x = block.position_x;
                            newBlock.position_y = block.position_y;
                            contentPages[block.i].blocks[block.j] = getBlockResizers(newBlock, templateBlocks);
                        }
                    });
                });
            });
        });
        return {
            currentPage: contentPages && contentPages.length >= edition.shown ? edition.shown : 0,
            pageAmount: edition.pages.length,
            templateSettings: edition.template,
            templateBlocks: edition.template.template_block_category,
            editionSettings: edition.settings,
            item: edition.item,
            contentPages,
            raster: edition.raster.pages,
            usedMedia: edition.used_media,
            totalBlockCount: edition.raster.block_count,
            pasteData: 0,
            copiedBlock: null,
            showTour: false,
            magneticBlocks: true,
            systemProgress: _jsx(ProgressBar, { variant: "danger", now: 0 }),
            filesToUpload: [],
            filesUploading: [],
            saving: false,
            editionId: edition.id,
            editionTitle: edition.title,
            campaign: edition.campaign,
            publisherInfo: edition.campaign ? edition.campaign.publisher_info : '',
            itemName: '',
            unsaved: false,
            blockContainer: null,
            activeHeight: 100,
            navEntry: [],
            saveCancel: null,
            goToLastPageState: false,
            resetPageState: false,
            updateBlocksState: false,
            uploadError: true,
            fontsToLoad: 0,
            showSettings: false,
            colorSettings: [],
            fontSizeSettings: {},
            showChangePageNumberOptionsForPage: -1,
            darkModeSettings: false,
        };
    });
    // Destructure state for easier access
    const { currentPage, pageAmount, templateSettings, templateBlocks, editionSettings, item, contentPages, raster, usedMedia, totalBlockCount, pasteData, copiedBlock, showTour, magneticBlocks, systemProgress, filesToUpload, filesUploading, saving, editionId, editionTitle, campaign, publisherInfo, itemName, unsaved, blockContainer, activeHeight, navEntry, goToLastPageState, resetPageState, updateBlocksState, uploadError, fontsToLoad, showSettings, colorSettings, fontSizeSettings, showChangePageNumberOptionsForPage, darkModeSettings, toolbar, } = state;
    /* Helper function to update state */
    const updateState = useCallback((newState) => {
        if (_isMounted.current) {
            setState((prev) => {
                const updatedState = typeof newState === 'function' ? newState(prev) : newState;
                return Object.assign(Object.assign({}, prev), updatedState);
            });
        }
    }, []);
    const unsavedRRef = useRef(unsavedR);
    const savingRRef = useRef(savingR);
    const fontsToLoadRef = useRef(fontsToLoad);
    useEffect(() => {
        unsavedRRef.current = unsavedR;
        savingRRef.current = savingR;
    }, [unsavedR, savingR]);
    useEffect(() => {
        fontsToLoadRef.current = fontsToLoad;
    }, [fontsToLoad]);
    // Component Did Mount
    useEffect(() => {
        var _a, _b, _c, _d;
        _isMounted.current = true;
        if (!may('ROLE_ROOT_EMPLOYEE', user.roles)) {
            doBlockForm(edition === null || edition === void 0 ? void 0 : edition.id);
        }
        getDarkMode();
        setVariables('resetTimeline');
        const name = edition.item.name;
        const newItemName = typeof name === 'object' ? getNameInCurrentLanguage(name, appIntl) : name;
        updateState({ itemName: newItemName });
        // Load fonts
        let fontsCount = 0;
        if (((_b = (_a = edition.template.target) === null || _a === void 0 ? void 0 : _a.fonts) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            fontsCount += edition.template.target.fonts.length;
        }
        if (edition.template.fonts.length > 0) {
            fontsCount += edition.template.fonts.length;
        }
        if (fontsCount > 0) {
            updateState({ fontsToLoad: fontsCount });
            const loadFont = (font, isTarget) => {
                const fontPath = isTarget
                    ? S3_LINKS.CLIENTS + edition.template.target.username + '/structure/' + font.file_name
                    : S3_LINKS.TEMPLATES + edition.template.id + '/structure/' + font.file_name;
                const junctionFont = new FontFace(font.css_path, `url(${fontPath})`);
                return junctionFont
                    .load()
                    .then((loadedTypeface) => {
                    document.fonts.add(loadedTypeface);
                    if (_isMounted.current) {
                        updateState((prev) => ({ fontsToLoad: prev.fontsToLoad - 1 }));
                    }
                })
                    .catch((err) => {
                    console.error('Font loading error:', err);
                });
            };
            // Load target fonts
            if ((_c = edition.template.target) === null || _c === void 0 ? void 0 : _c.fonts) {
                edition.template.target.fonts.forEach((font) => loadFont(font, true));
            }
            // Load template fonts
            edition.template.fonts.forEach((font) => loadFont(font, false));
        }
        // Show tour if needed
        if (showTourInit) {
            const options = {
                title: messages.editor.new_here,
                message: messages.editor.first_start,
                buttons: [
                    {
                        label: messages.editor.yes_absolutely,
                        onClick: () => updateState({ showTour: true }),
                    },
                    {
                        label: messages.editor.im_fine,
                        onClick: () => { },
                    },
                ],
                childrenElement: () => _jsx("div", {}),
                closeOnEscape: true,
                closeOnClickOutside: true,
            };
            confirmAlert(options);
        }
        // Font check interval
        fontCheckRef.current = setInterval(() => {
            if (!_isMounted.current)
                return;
            if (fontsToLoadRef.current <= 0) {
                clearInterval(fontCheckRef.current);
                updateState((prev) => (Object.assign({}, prev))); // forceUpdate
            }
        }, 1000);
        /* Upload check interval via useEffect with deps below
        uploadCheckRef.current = setInterval(() => {
          if (!_isMounted.current) return;
          if (filesToUpload.length > 0 && filesUploading.length === 0 && !savingR) {
            uploading();
          }
        }, 5000);
         */
        // Virtual keyboard handling
        if ('virtualKeyboard' in navigator) {
            navigator.virtualKeyboard.overlaysContent = false;
            virtualKeyboardHandlerRef.current = () => {
                const it = document.getElementsByClassName('ScrollbarsCustom-Scroller');
                if (it[0]) {
                    it[0].scrollBy(-30, -40);
                }
            };
            navigator.virtualKeyboard.addEventListener('geometrychanged', virtualKeyboardHandlerRef.current);
        }
        // Auto-save setup
        const videoExport = templateSettings.export_type.value === '000000000000000000000004';
        const disableAutosave = ((edition === null || edition === void 0 ? void 0 : edition.placed_orders) && edition.placed_orders.length > 0) || videoExport;
        if (((_d = user.profile) === null || _d === void 0 ? void 0 : _d.editor_autosave) !== false && !disableAutosave) {
            autoSaveRef.current = setInterval(() => {
                if (!_isMounted.current)
                    return;
                if (unsavedRRef.current && !savingRRef.current) {
                    saveContentRef.current();
                }
            }, 300000);
        }
        // Cleanup function for window unload
        const handleBeforeUnload = () => {
            doReleaseForm(edition.id);
            cleanupIntervals();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        // return === componentDidUnmount
        return () => {
            _isMounted.current = false;
            doReleaseForm(editionId);
            cleanupIntervals();
            if (virtualKeyboardHandlerRef.current && 'virtualKeyboard' in navigator) {
                navigator.virtualKeyboard.removeEventListener('geometrychanged', virtualKeyboardHandlerRef.current);
            }
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    const saveContent = useCallback(() => {
        if (!templateSettings.initialized) {
            return;
        }
        if (filesUploading.length === 0 && !savingR) {
            setVariables('savingtrue');
            const rasterToSave = {
                block_count: totalBlockCount,
                pages: raster,
            };
            let changeString = messages.editor.no_changes;
            if (Object.keys(changesR).length > 0) {
                changeString = '';
                _.forEach(changesR, (changedPage, key) => {
                    if (key === '0' && Object.keys(changedPage).length > 0) {
                        changeString += '<b>' + messages.editor.changes_on_document + '</b><br/>';
                    }
                    else if (Object.keys(changedPage).length > 0) {
                        changeString += '<b>' + messages.editor.changes_on_page + ' ' + key + ':</b><br/>';
                    }
                    _.forIn(changedPage, (changedBlock) => {
                        changeString += changedBlock.text + '<br/>';
                    });
                    changeString += '<br/>';
                });
            }
            const contentToSave = {
                raster: rasterToSave,
                pages: contentPages,
                shown: currentPage,
                usedMedia,
                title: editionTitle,
                settings: editionSettings,
                changes: changeString,
                pageAmount: contentPages.length,
            };
            setVariables(false);
            saveContentR(editionId, contentToSave);
        }
        else if (filesUploading.length > 0) {
            setVariables('waitForSavingTrue');
        }
    }, [
        templateSettings,
        filesUploading,
        savingR,
        totalBlockCount,
        raster,
        changesR,
        contentPages,
        currentPage,
        usedMedia,
        editionTitle,
        editionSettings,
        editionId,
        messages,
        setVariables,
        saveContentR,
    ]);
    const saveContentRef = useRef(saveContent);
    useEffect(() => {
        saveContentRef.current = saveContent;
    }, [saveContent]);
    useEffect(() => {
        if (!_isMounted.current)
            return;
        if (filesToUpload.length > 0 && filesUploading.length === 0 && !savingR) {
            uploading();
        }
    }, [filesToUpload, filesUploading, savingR]);
    // Refs prev values
    const prevLinkDataRRef = useRef(linkDataR);
    const prevForwardingRRef = useRef(forwardingR);
    const prevWaitForSavingRef = useRef(waitForSaving);
    const prevShowErrorMessageRef = useRef(showErrorMessage);
    // 1. Link Data Navigation
    useEffect(() => {
        if (!_isMounted.current)
            return;
        if (linkDataR !== undefined && linkDataR !== prevLinkDataRRef.current) {
            history.push(appIntl.urlPrefix + 'editor/' + linkDataR);
            window.location.reload();
        }
        prevLinkDataRRef.current = linkDataR;
    }, [linkDataR, history, appIntl.urlPrefix]);
    // 2. Forwarding
    useEffect(() => {
        if (!_isMounted.current)
            return;
        if (forwardingR && forwardingR !== prevForwardingRRef.current) {
            setVariables('forwardingfalse');
            history.push(appIntl.urlPrefix + 'account/settings/producttemplates');
        }
        prevForwardingRRef.current = forwardingR;
    }, [forwardingR, setVariables, history, appIntl.urlPrefix]);
    // 3. Auto-Save
    useEffect(() => {
        if (!_isMounted.current)
            return;
        if (!waitForSaving && waitForSaving !== prevWaitForSavingRef.current) {
            if (unsavedRRef.current && !savingRRef.current) {
                saveContentRef.current();
            }
        }
        prevWaitForSavingRef.current = waitForSaving;
    }, [waitForSaving, saveContent]);
    // 4. Error Messages
    useEffect(() => {
        if (!_isMounted.current)
            return;
        if (showErrorMessage && showErrorMessage !== prevShowErrorMessageRef.current) {
            const options = {
                customUI: ({ onClose }) => {
                    return (_jsxs("div", { className: "react-confirm-alert-body", children: [_jsx("h1", { children: messages.editor.saving_failed }), _jsx("p", { children: messages.editor.try_again }), _jsx("div", { className: "react-confirm-alert-button-group", style: { width: '100%', margin: '0 auto' }, children: _jsx(Button, { style: { margin: '0 auto', marginTop: '20px', width: '100px' }, variant: "primary", onClick: onClose, children: "OK" }, "ButtonOnClose2") })] }));
                },
                childrenElement: () => _jsx("div", {}),
                closeOnEscape: true,
                closeOnClickOutside: true,
            };
            confirmAlert(options);
        }
        prevShowErrorMessageRef.current = showErrorMessage;
    }, [showErrorMessage, messages]);
    // unsaved
    useEffect(() => {
        if (!_isMounted.current)
            return;
        setUnsaved(unsavedR);
    }, [unsavedR, setUnsaved]);
    // Cleanup intervals
    const cleanupIntervals = useCallback(() => {
        if (autoSaveRef.current)
            clearInterval(autoSaveRef.current);
        if (fontCheckRef.current)
            clearInterval(fontCheckRef.current);
        if (waitForSavingRef.current)
            clearTimeout(waitForSavingRef.current);
    }, []);
    // Dark Mode functions
    const setDarkMode = useCallback((username, isDarkMode) => {
        try {
            const newDarkModeSettings = { username, isDarkMode };
            updateState({ darkModeSettings: newDarkModeSettings });
            localStorage.setItem('darkMode', JSON.stringify(newDarkModeSettings));
        }
        catch (error) {
            console.error('Cannot set Darkmode', error);
        }
    }, [updateState]);
    const getDarkMode = useCallback(() => {
        try {
            const storedData = localStorage.getItem('darkMode');
            if (storedData) {
                updateState({ darkModeSettings: JSON.parse(storedData) });
            }
        }
        catch (error) {
            console.error('Cannot load Darkmode', error);
        }
    }, [updateState]);
    // Page management functions
    const resetPage = useCallback((option) => {
        const pageNameIndex = getPageNameIndex(currentPage, templateSettings, contentPages.length);
        if (templateSettings.pages[pageNameIndex].endless) {
            updateState({ resetPageState: option, updateBlocksState: option });
        }
    }, [currentPage, templateSettings, contentPages.length, updateState]);
    const resetStates = useCallback((pageNameIndex) => {
        if (templateSettings.pages[pageNameIndex].endless) {
            updateState({ resetPageState: false, updateBlocksState: false });
        }
    }, [templateSettings, updateState]);
    const updateCurrentPage = useCallback((pageNumber) => {
        updateState({
            currentPage: pageNumber,
            blockContainer: null,
        });
    }, [updateState]);
    const setCurrentPage = useCallback((e) => {
        updateCurrentPage(parseInt(e.currentTarget.innerText, 10) - 1);
    }, [updateCurrentPage]);
    const selectPage = useCallback((e) => {
        let nextPage = parseInt(e.currentTarget.getAttribute('data-page') || '0', 10);
        if (Number.isNaN(nextPage))
            nextPage = 0;
        updateCurrentPage(nextPage);
        updateState({ updateBlocksState: true });
    }, [updateCurrentPage, updateState]);
    const goToLastPage = useCallback((isLastPage) => {
        const pageNameIndex = getPageNameIndex(currentPage, templateSettings, contentPages.length);
        if (templateSettings.pages[pageNameIndex].endless) {
            updateState({ goToLastPageState: isLastPage });
        }
    }, [currentPage, templateSettings, contentPages.length, updateState]);
    const insertContentBlock = useCallback((blockId, index, currentPagesNew, optionAl, indexTwo, newRaster, newPageAmount, newPages) => {
        let result;
        goToLastPage(true);
        const currentRaster = newRaster || raster;
        const currentPageAmount = newPageAmount || pageAmount;
        const currentContentPages = newPages || contentPages;
        if (currentPage === templateSettings.sample_page_number - 1 && !templateSettings.initialized) {
            result = insertBlock(_.cloneDeep(currentContentPages), currentRaster, totalBlockCount + 1, index.toString().split('.'), templateBlocks, currentPage, templateSettings, currentPageAmount, blockContainer, 'samplePage');
            updateState(result);
            // Tooltip.rebuild();
        }
        else if (currentPage === templateSettings.sample_page_number_two - 1 && !templateSettings.initialized) {
            result = insertBlock(_.cloneDeep(currentContentPages), currentRaster, totalBlockCount + 1, index.toString().split('.'), templateBlocks, currentPage, templateSettings, currentPageAmount, blockContainer, 'samplePageTwo');
            updateState(result);
            // Tooltip.rebuild();
        }
        else if (optionAl === 'addPage') {
            result = insertBlock(_.cloneDeep(currentContentPages), currentRaster, totalBlockCount + 1, index, templateBlocks, currentPagesNew, templateSettings, currentPageAmount, null, // blockContainer
            'addPage', indexTwo);
            updateState(result);
            // Tooltip.rebuild();
        }
        else {
            result = insertBlock(_.cloneDeep(currentContentPages), currentRaster, totalBlockCount + 1, index.toString().split('.'), templateBlocks, currentPage, templateSettings, currentPageAmount, blockContainer, 'single');
            updateState(result);
            // Tooltip.rebuild();
        }
        if (result && result.newId) {
            setChangesR(createTimelineBlockEntry(changesR, result.newId, currentPage, messages.editor.content_block_inserted, 'insert'));
        }
        else {
            console.error('Insert block failed - no result or newId');
        }
    }, [
        contentPages,
        raster,
        totalBlockCount,
        templateBlocks,
        currentPage,
        templateSettings,
        pageAmount,
        blockContainer,
        setChangesR,
        changesR,
        messages,
        updateState,
        goToLastPage,
    ]);
    const copyContentBlock = useCallback((e, type = '') => {
        const target = e.currentTarget;
        updateState({
            copiedBlock: copyBlock(target, contentPages[parseInt(currentPage.toString(), 10)], raster, type),
            pasteData: 1,
        });
    }, [contentPages, currentPage, raster, updateState]);
    const pasteContentBlock = useCallback((e, type = '') => {
        let targetIndex;
        let innerTargetIndex;
        if (type === 'inner') {
            targetIndex =
                e.currentTarget.getAttribute('data-parent') === '-1'
                    ? -1
                    : _.findIndex(contentPages[currentPage].blocks, { id: e.currentTarget.getAttribute('data-parent') });
            innerTargetIndex = _.findIndex(contentPages[currentPage].blocks[targetIndex].blocks, {
                id: e.currentTarget.getAttribute('data-block'),
            });
        }
        else {
            targetIndex =
                e.currentTarget.getAttribute('data-block') === '-1'
                    ? -1
                    : _.findIndex(contentPages[currentPage].blocks, { id: e.currentTarget.getAttribute('data-block') });
        }
        setVariables('unsavedtrue');
        const pasteResult = pasteBlock(totalBlockCount, targetIndex, currentPage, contentPages[currentPage], raster, copiedBlock, usedMedia, type, innerTargetIndex);
        const newContentPages = [...contentPages];
        newContentPages[currentPage] = pasteResult.contentPage;
        setChangesR(createTimelineBlockEntry(changesR, pasteResult.newId, currentPage, messages.editor.content_block_copied, 'copy'));
        updateState({
            contentPages: newContentPages,
            copiedBlock: null,
            pasteData: 0,
            raster: pasteResult.changedRaster,
            totalBlockCount: pasteResult.newTotalBlockCount,
            usedMedia: pasteResult.usedMedia,
            unsaved: true,
            navEntry: pasteResult.navEntry,
        });
        resetPage(true);
    }, [
        contentPages,
        currentPage,
        totalBlockCount,
        raster,
        copiedBlock,
        usedMedia,
        setChangesR,
        changesR,
        messages,
        setVariables,
        updateState,
        resetPage,
    ]);
    const changeContentBlock = useCallback((e) => {
        const sourceId = e.currentTarget.getAttribute('data-block');
        const targetId = e.currentTarget.getAttribute('data-target');
        if (!sourceId || !targetId)
            return;
        setVariables('unsavedtrue');
        const result = changeBlock(sourceId, targetId, contentPages, raster, currentPage, templateSettings.export_type.value);
        setChangesR(createTimelineBlockEntry(changesR, sourceId, currentPage, messages.editor.content_blocks_switched, 'shift'));
        updateState({
            raster: result.raster,
            contentPages: result.contentPages,
            unsaved: true,
        });
        resetPage(true);
    }, [
        contentPages,
        raster,
        currentPage,
        templateSettings,
        setChangesR,
        changesR,
        messages,
        setVariables,
        updateState,
        resetPage,
    ]);
    const resetContentBlock = useCallback((e) => {
        const rasterId = e.getAttribute('data-block');
        const blockId = e.getAttribute('data-template');
        setVariables('unsavedtrue');
        setChangesR(createTimelineBlockEntry(changesR, rasterId, currentPage, messages.editor.content_block_reset, 'reset'));
        const resetResult = resetBlock(rasterId, blockId, contentPages, currentPage, templateBlocks, usedMedia);
        updateState(resetResult);
        resetPage(true);
    }, [
        contentPages,
        currentPage,
        templateBlocks,
        usedMedia,
        setChangesR,
        changesR,
        messages,
        setVariables,
        updateState,
        resetPage,
    ]);
    const resizeContentBlock = useCallback((e, dummy) => {
        let blockId;
        let changeId;
        if (dummy !== undefined) {
            blockId = e;
            changeId = dummy;
        }
        else {
            blockId = e.getAttribute('data-block');
            changeId = e.getAttribute('data-template');
        }
        const resizeResult = resizeBlock(templateBlocks, contentPages[currentPage], raster, currentPage, blockId, changeId);
        const newContentPages = [...contentPages];
        newContentPages[currentPage] = resizeResult.contentPage;
        setVariables('unsavedtrue');
        setChangesR(createTimelineBlockEntry(changesR, blockId, currentPage, messages.editor.content_block_resize, 'resize'));
        updateState({
            contentPages: newContentPages,
            raster: resizeResult.changedRaster,
            unsaved: true,
        });
        return true;
    }, [contentPages, currentPage, raster, templateBlocks, setChangesR, changesR, messages, setVariables, updateState]);
    const deleteChild = useCallback((parent) => {
        _.forEach(contentPages[currentPage].blocks, (block) => {
            const blockCombinationChild = block.block_combination_child.split(',');
            _.forEach(blockCombinationChild, (blockCC) => {
                if (blockCC === parent) {
                    setChangesR(createTimelineBlockEntry(changesR, block.id, currentPage, messages.editor.content_block_removed, 'delete'));
                    const removeResult = removeBlock(currentPage, contentPages, raster, block.id, block.page_space_needed, magneticBlocks, usedMedia);
                    updateState(removeResult);
                    deleteSelectedColor(block.id, 'no_block_container');
                }
            });
        });
    }, [contentPages, currentPage, raster, magneticBlocks, usedMedia, setChangesR, changesR, messages, updateState]);
    const removeContentBlock = useCallback((e) => {
        var _a, _b, _c, _d;
        const sourceRasterId = e.getAttribute('data-block');
        const sourceSpace = parseInt(e.getAttribute('data-space'), 10);
        // cross-page auto-delete of the child elements is not necessary at the moment,
        // since the parent - child combinations only work on a page-by-page basis
        // find the parent of the block being removed (if any)
        const indexOfParent = _.findIndex((_a = contentPages[currentPage]) === null || _a === void 0 ? void 0 : _a.blocks, ['id', sourceRasterId]);
        const parent = (_c = (_b = contentPages[currentPage]) === null || _b === void 0 ? void 0 : _b.blocks[indexOfParent]) === null || _c === void 0 ? void 0 : _c.block_combination_parent;
        // collect parent chain (parents of parents ...)
        const allParent = [];
        if (parent && parent !== '')
            allParent.push(parent);
        // iterate over the growing list to discover higher-level parents
        for (let i = 0; i < allParent.length; i++) {
            const p = allParent[i];
            if (!p)
                continue;
            // scan all blocks on the current page to see which declare p as child
            _forEach(((_d = contentPages[currentPage]) === null || _d === void 0 ? void 0 : _d.blocks) || [], (block) => {
                const childStr = block.block_combination_child;
                if (!childStr)
                    return;
                const childIds = String(childStr).split(',');
                _forEach(childIds, (blockCC) => {
                    if (blockCC === p) {
                        const parentOfBlock = block.block_combination_parent;
                        if (parentOfBlock && parentOfBlock !== '' && allParent.indexOf(parentOfBlock) === -1) {
                            allParent.push(parentOfBlock);
                        }
                    }
                });
            });
        }
        // delete from bottom to top
        const reversedParent = allParent.slice().reverse();
        _forEach(reversedParent, (p) => {
            if (p && p !== '') {
                deleteChild(p);
            }
        });
        setVariables('unsavedtrue');
        setChangesR(createTimelineBlockEntry(changesR, sourceRasterId, currentPage, messages.editor.content_block_removed, 'delete'));
        const removeResult = removeBlock(currentPage, contentPages, raster, sourceRasterId, sourceSpace, magneticBlocks, usedMedia);
        // If RemoveResult contains contentPages, we break the reference
        // so that child components immediately pick up the change!
        // Important to sync allUsedBlocks
        if (removeResult && removeResult.contentPages) {
            removeResult.contentPages = [...removeResult.contentPages];
        }
        updateState(removeResult);
        deleteSelectedColor(sourceRasterId, 'no_block_container');
        resetPage(true);
    }, [
        contentPages,
        currentPage,
        raster,
        magneticBlocks,
        usedMedia,
        deleteChild,
        setChangesR,
        changesR,
        messages,
        setVariables,
        updateState,
        resetPage,
    ]);
    const selectBlockContainer = useCallback((blockId) => {
        updateState({ blockContainer: blockId });
    }, [updateState]);
    const unselectBlockContainer = useCallback(() => {
        updateState({ blockContainer: null });
    }, [updateState]);
    const setToolbarOptions = useCallback((toolbarOptions) => {
        // not in use
        updateState((prev) => ({
            toolbar: Object.assign(Object.assign({}, prev.toolbar), toolbarOptions),
        }));
    }, [updateState]);
    const updateInnerBlock = useCallback((idPageBlock, blocks, spaceConsumed, usedMediaUpdate, page, drag, idInnerBlock, initialUpdate, paramList, type) => {
        const onPage = page !== null && page !== void 0 ? page : currentPage;
        if (initialUpdate) {
            updateState((prevState) => {
                const dataContentPages = _cloneDeep(prevState.contentPages);
                const elementOnPage = _find(dataContentPages[onPage].blocks, { id: idPageBlock });
                const innerBlockElement = _find(elementOnPage.blocks, { id: idInnerBlock });
                const { params } = innerBlockElement;
                _forEach(paramList, ({ name, value, error, filter, url }) => {
                    const paramIndex = _findIndex(params, ['name', name]);
                    const paramValue = { name, value, errors: error, filter, url };
                    if (paramIndex >= 0) {
                        params[paramIndex] = paramValue;
                    }
                    else if (type === 'creatomate') {
                        addAndSortParams(params, paramValue);
                    }
                    else {
                        params.push(paramValue);
                    }
                });
                elementOnPage.space_consumed = spaceConsumed;
                setVariables('unsavedtrue');
                return {
                    contentPages: dataContentPages,
                    unsaved: true,
                    usedMedia: usedMediaUpdate,
                };
            });
        }
        else {
            const data = _.cloneDeep(contentPages);
            // legacy - prone to errors if onPage not declared ->
            const element = _.find(data[onPage].blocks, { id: idPageBlock });
            // ROBUST: Finds the parent block regardless of which page it is currently on.
            /*
              let element: any = null;
    
              for (const page of data) {
                const found = _.find(page.blocks, { id: idPageBlock });
                if (found) {
                  element = found;
                  break;
                }
              }
            */
            if (!element) {
                console.warn(`Block with ID ${idPageBlock} could not be found in page data`);
                return;
            }
            element.blocks = blocks;
            if (drag) {
                setVariables('unsavedtrue');
                updateState({ contentPages: data, unsaved: true });
            }
            else {
                element.space_consumed = spaceConsumed;
                setVariables('unsavedtrue');
                updateState({ contentPages: data, unsaved: true, usedMedia: usedMediaUpdate });
            }
        }
    }, [contentPages, currentPage, setVariables, updateState]);
    const updateBlock = useCallback((id, blocks, drag) => {
        const onPage = currentPage;
        const data = _.cloneDeep(contentPages);
        data[onPage].blocks = blocks;
        if (drag) {
            setVariables('unsavedtrue');
            updateState({
                contentPages: data,
                unsaved: true,
            });
        }
    }, [contentPages, currentPage, setVariables, updateState]);
    const initDefaultPosition = useCallback(() => {
        const _contentPages = _.cloneDeep(contentPages);
        _.forEach(_contentPages, (pages) => {
            _.forEach(pages.blocks, (block) => {
                const { position_x, position_y, template } = block;
                const isNotSet = (value) => value === undefined || value === null;
                const bothPositionsNotSet = isNotSet(position_x) && isNotSet(position_y);
                const validTemplates = ['draggable', 'allowdraganddrop'];
                const isTemplateValid = template && validTemplates.some((templateName) => template.includes(templateName));
                if (bothPositionsNotSet && isTemplateValid) {
                    let blockTemplate = _.cloneDeep(block.template);
                    blockTemplate = blockTemplate.toLowerCase();
                    block.position_x = getNumericValue(blockTemplate, 'defaultpositionx') || 0;
                    block.position_y = getNumericValue(blockTemplate, 'defaultpositiony') || 0;
                }
            });
        });
        updateState({
            contentPages: _contentPages,
        });
    }, [contentPages, updateState]);
    const addAndSortParams = useCallback((params, paramValue) => {
        params.push(paramValue);
        params.sort((a, b) => {
            var _a, _b;
            const numA = parseInt(((_a = a.name.match(/\d+$/)) === null || _a === void 0 ? void 0 : _a[0]) || '0', 10);
            const numB = parseInt(((_b = b.name.match(/\d+$/)) === null || _b === void 0 ? void 0 : _b[0]) || '0', 10);
            return numA - numB;
        });
    }, []);
    const updateParam = useCallback((id, name, value, errors, name2 = '', value2 = '', _currentPage = null, initialUpdate = false, type = '') => {
        const error = {};
        if (errors !== null) {
            _.forEach(errors, ({ overflow, default_image, resolution_warning }) => {
                error.overflow = overflow;
                error.default_image = default_image;
                error.resolution_warning = resolution_warning;
            });
        }
        let params = [{ name, value, error }];
        if (name2 !== '' && value2 !== '') {
            params = [
                { name, value, error },
                { name: name2, value: value2, error: {} },
            ];
        }
        const cPage = _currentPage !== null ? _currentPage : currentPage;
        updateParams(id, params, errors, cPage, type);
        return true;
    }, [currentPage]);
    const updateSpecialBlockAttributes = useCallback((id, name, value, thumb, errors, filter, url) => {
        const error = {};
        if (errors !== null) {
            error.overflow = errors === null || errors === void 0 ? void 0 : errors.overflow;
            error.default_image = errors === null || errors === void 0 ? void 0 : errors.default_image;
            error.resolution_warning = errors === null || errors === void 0 ? void 0 : errors.resolution_warning;
        }
        const params = [{ name, value, thumb, error, filter, url }];
        updateParams(id, params, errors, currentPage);
        return true;
    }, [currentPage]);
    const updateParams = useCallback((id, paramList, errors, currentPageUpdate, type = '') => {
        let finalNewChangesR = null;
        updateState((prevState) => {
            const data = _.cloneDeep(prevState.contentPages);
            let element = _.find(data[currentPageUpdate].blocks, { id });
            if (element === undefined) {
                const foundPage = _.findIndex(raster, (innerArray) => {
                    return _.includes(innerArray, id);
                });
                if (foundPage >= 0) {
                    element = _.find(data[foundPage].blocks, { id });
                }
            }
            if (!element)
                return prevState;
            const { params } = element;
            const pIndex = (currentPageUpdate + 1).toString();
            const newChangesR = _.cloneDeep(changesR);
            if (typeof newChangesR === 'undefined' || typeof newChangesR[pIndex] === 'undefined') {
                newChangesR[pIndex] = [];
            }
            _.forEach(paramList, ({ name, value, error, filter, url, thumb }) => {
                const paramIndex = _.findIndex(params, ['name', name]);
                const paramValue = { name, value, errors: error, filter, url, thumb };
                let newChanges;
                if (value.includes(S3_DOMAIN)) {
                    newChanges = {
                        text: messages.editor.new_picture_inserted,
                        action: 'upload',
                    };
                }
                else {
                    newChanges = {
                        text: messages.editor.text_changed,
                        action: 'text',
                    };
                }
                newChangesR[pIndex][id] = newChanges;
                if (paramIndex >= 0) {
                    params[paramIndex] = paramValue;
                }
                else if (type === 'creatomate') {
                    addAndSortParams(params, paramValue);
                }
                else {
                    params.push(paramValue);
                }
            });
            // setVariables('unsavedtrue');
            // setChangesR(newChangesR);
            finalNewChangesR = newChangesR;
            return {
                contentPages: data,
                unsaved: true,
                updateBlocksState: true,
            };
        });
        if (finalNewChangesR) {
            setTimeout(() => {
                setVariables('unsavedtrue');
                setChangesR(finalNewChangesR);
            }, 0);
        }
    }, [changesR, raster, setChangesR, setVariables, messages, addAndSortParams, updateState]);
    const saveDescription = useCallback((data, index) => {
        const usedMediaClone = _.cloneDeep(usedMedia);
        usedMediaClone[index].imgDescription = data;
        updateState({ usedMedia: usedMediaClone });
        setVariables('unsavedtrue');
    }, [usedMedia, setVariables, updateState]);
    const showResolutionError = () => {
        toast.error(_jsx("b", { children: messages.editor.resolution_too_low }));
    };
    // File upload handling
    const uploading = useCallback(() => {
        const filesUploadingCopy = _.cloneDeep(filesToUpload);
        const { CancelToken } = Axios;
        _.forEach(filesUploadingCopy, (file, i) => {
            filesUploadingCopy[i].completed = 0;
            const imageData = new FormData();
            let thumb = '';
            let originalName = '';
            let copyright = '';
            let id = 0;
            if (file.imageKey === null || file.imageKey === 'video') {
                imageData.append('file', file.image);
            }
            else {
                const imageHelper = _.findIndex(usedMedia, function (o) {
                    return o.key === file.imageKey;
                });
                if (imageHelper !== -1) {
                    thumb = usedMedia[imageHelper].thumb;
                    originalName = usedMedia[imageHelper].originalname;
                    copyright = usedMedia[imageHelper].copyright;
                    const mediaHelper = _.findIndex(usedMedia, function (o) {
                        return o.key === file.imageKey && o.blockid === file.id && o.param === file.name;
                    });
                    if (mediaHelper >= 0) {
                        id = usedMedia[mediaHelper].id;
                    }
                }
                else {
                    originalName = file.filename;
                    thumb = file.thumb;
                    copyright = file.copyright;
                }
            }
            const args = {
                id,
                uploadType: file.imageKey === 'video' ? 'userVideo' : 'userImage',
                data: file.data,
                blockId: file.id,
                name: file.name,
                imageKey: file.imageKey === 'video' ? null : file.imageKey,
                thumb,
                originalname: originalName,
                width: file.width,
                height: file.height,
                copyright,
                imgDescription: file.imgDescription,
                errors: file.errors,
                filtersAsString: file.filtersAsString,
            };
            imageData.append('json', JSON.stringify(args));
            Axios.post('/api/editions/' + editionId + '/images.json', imageData, {
                cancelToken: new CancelToken(function executor(c) {
                    filesUploadingCopy[i].cancel = c;
                }),
            })
                .then((response) => {
                setVariables('unsavedtrue');
                let value = response.data.path + response.data.file;
                const pathOfThumb = S3_LINKS.EDITION_IMGS_THUMB;
                const thumb = pathOfThumb + response.data.thumb;
                if (file.imageKey === 'video') {
                    value = 'link#aaa#' + response.data.path + response.data.file + '#aaa#';
                }
                if (file.ownKey === 'video-url') {
                    value =
                        'video-url#aaa#' +
                            response.data.path +
                            response.data.file +
                            '#aaa#' +
                            'undefined' +
                            '#aaa#' +
                            file.imageOrVideoEditWidth +
                            '#aaa#' +
                            file.imageOrVideoEditHeight;
                }
                if (file.ownKey === 'image-url') {
                    value =
                        'image-url#aaa#' +
                            response.data.path +
                            response.data.file +
                            '#aaa#' +
                            file.duration +
                            '#aaa#' +
                            file.imageOrVideoEditWidth +
                            '#aaa#' +
                            file.imageOrVideoEditHeight;
                }
                if (file.ownKey === 'sliderImageDefault') {
                    const cutImage = response.data.path + response.data.file;
                    const copyrightSliderImage = response.data.usedMedia ? response.data.usedMedia.copyright : '';
                    const IMG_ARR = [cutImage, '', '', copyrightSliderImage];
                    file.sliderImage.push(IMG_ARR);
                    let param = '';
                    _.forEach(file.sliderImage, (sliderData, i) => {
                        param += sliderData[0] + '#aaa#' + sliderData[1] + '#aaa#' + sliderData[2] + '#aaa#' + sliderData[3];
                        if (i < file.sliderImage.length - 1) {
                            param += '#cc#';
                        }
                    });
                    value = param + '#opt#' + file.autoplay;
                }
                if (file.ownKey === 'sliderImageReverse') {
                    const cutImage = response.data.path + response.data.file;
                    const copyrightSliderImage = response.data.usedMedia ? response.data.usedMedia.copyright : '';
                    const IMG_ARR = [cutImage, '', '', copyrightSliderImage];
                    file.sliderImage.unshift(IMG_ARR);
                    let param = '';
                    _.forEach(file.sliderImage, (sliderData, i) => {
                        param += sliderData[0] + '#aaa#' + sliderData[1] + '#aaa#' + sliderData[2] + '#aaa#' + sliderData[3];
                        if (i < file.sliderImage.length - 1) {
                            param += '#cc#';
                        }
                    });
                    value = param + '#opt#' + file.autoplay;
                }
                const copyright = response.data.usedMedia ? response.data.usedMedia.copyright : null;
                const { name, errors, filterAsString } = file;
                const copyName = 'copyright_' + file.name;
                const { id: fileId } = file;
                const { page } = file;
                const currentUploadOfThisImage = _.findIndex(filesUploadingCopy, { id: fileId, name });
                if (errors === null || errors === void 0 ? void 0 : errors.resolution_warning) {
                    showResolutionError();
                }
                if (currentUploadOfThisImage >= 0) {
                    filesUploadingCopy.splice(currentUploadOfThisImage, 1);
                }
                const usedImage = checkIfMediaBlockExists(usedMedia, response.data.usedMedia.blockid, response.data.usedMedia.param);
                let newCut = -1;
                if (usedImage >= 0) {
                    if (file.imageKey !== null) {
                        newCut = checkIfMediaStaysSame(usedMedia, response.data.usedMedia.blockid, response.data.usedMedia.param, response.data.usedMedia.key);
                    }
                    if (file.imageKey === null || newCut < 0) {
                        const wasUnused = checkIfMediaIsUnused(usedMedia, response.data.usedMedia.key);
                        const alreadyUnused = checkIfMediaIsUnused(usedMedia, usedMedia[usedImage].key);
                        if (wasUnused >= 0) {
                            usedMedia[wasUnused].blockid = response.data.usedMedia.blockid;
                            usedMedia[wasUnused].param = response.data.usedMedia.param;
                            if (alreadyUnused >= 0) {
                                usedMedia.splice(usedImage, 1);
                            }
                            else {
                                usedMedia[usedImage].blockid = 'unused';
                            }
                        }
                        else {
                            if (alreadyUnused < 0) {
                                const saveMedia = _.cloneDeep(usedMedia[usedImage]);
                                saveMedia.blockid = 'unused';
                                usedMedia.push(saveMedia);
                            }
                            usedMedia[usedImage] = response.data.usedMedia;
                            usedMedia[usedImage].copyright = copyright;
                        }
                    }
                }
                else {
                    usedMedia.push(response.data.usedMedia);
                }
                updateState({
                    filesUploading: filesUploadingCopy,
                    usedMedia,
                    uploadError: true,
                });
                if (copyright) {
                    let _copyright;
                    if (copyright.includes('<p>')) {
                        _copyright = copyright;
                    }
                    else {
                        _copyright = '<p>' + copyright + '</p>';
                    }
                    if (!file.updateF) {
                        updateParams(fileId, [
                            { name, value, thumb, error: errors, filter: filterAsString },
                            { name: copyName, value: _copyright },
                        ], errors, page);
                    }
                    else {
                        file.updateF(fileId, [
                            { name, value, thumb, error: errors, filter: filterAsString },
                            { name: copyName, value: _copyright },
                        ], errors, page);
                    }
                }
                else if (!file.updateF) {
                    updateParams(fileId, [{ name, value, thumb, error: errors, filter: filterAsString }], errors, page);
                }
                else {
                    file.updateF(fileId, [{ name, value, thumb, error: errors, filter: filterAsString }], errors, page);
                }
                resetPage(true);
                setVariables('waitForSavingFalse');
            })
                .catch((error) => {
                let errorMessage = messages.editor.try_again;
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                const options = {
                    customUI: ({ onClose }) => {
                        return (_jsxs("div", { className: "react-confirm-alert-body", children: [_jsx("h1", { children: messages.editor.upload_failed }), _jsx("p", { className: "break_word", children: errorMessage }), _jsx("div", { className: "react-confirm-alert-button-group", style: { width: '100%', margin: '0 auto' }, children: _jsx(Button, { style: { margin: '0 auto', marginTop: '20px', width: '100px' }, variant: "primary", onClick: onClose, children: "OK" }, "ButtonOnClose") })] }));
                    },
                    childrenElement: () => _jsx("div", {}),
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                };
                confirmAlert(options);
                updateState({
                    uploadError: true,
                });
                if (Axios.isCancel(error)) {
                    console.log('post Request canceled');
                }
                else {
                    console.log('cancel', error);
                }
                filesUploadingCopy.splice(i, 1);
                updateState({
                    filesUploading: filesUploadingCopy,
                });
            });
        });
        updateState({
            filesToUpload: [],
            filesUploading: filesUploadingCopy,
            uploadError: false,
        });
    }, [filesToUpload, usedMedia, editionId, setVariables, messages, resetPage, updateParams, updateState]);
    const uploadImage = useCallback((id, image, imageKey, name, data, width, height, filename, thumb, copyright, updateF = null, sliderImage = null, ownKey = '', imgDescription = '', autoplay = false, duration = 0, imageOrVideoEditWidth = 0, imageOrVideoEditHeight = 0, errors, filterAsString) => {
        const currentUploadOfThisImage = _.findKey(filesUploading, { id, name });
        if (typeof currentUploadOfThisImage !== 'undefined') {
            filesUploading[currentUploadOfThisImage].cancel();
        }
        const currentScheduleOfThisImage = _.findKey(filesToUpload, { id, name });
        const newFilesToUpload = [...filesToUpload];
        if (typeof currentScheduleOfThisImage !== 'undefined') {
            newFilesToUpload[currentScheduleOfThisImage] = {
                id,
                name,
                image,
                imageKey,
                data,
                page: currentPage,
                completed: 0,
                width,
                height,
                filename,
                thumb,
                copyright,
                updateF,
                sliderImage,
                ownKey,
                imgDescription,
                autoplay,
                duration,
                imageOrVideoEditWidth,
                imageOrVideoEditHeight,
                errors,
                filterAsString,
            };
        }
        else {
            newFilesToUpload.push({
                id,
                name,
                image,
                imageKey,
                data,
                page: currentPage,
                completed: 0,
                width,
                height,
                filename,
                thumb,
                copyright,
                updateF,
                sliderImage,
                ownKey,
                imgDescription,
                autoplay,
                duration,
                imageOrVideoEditWidth,
                imageOrVideoEditHeight,
                errors,
                filterAsString,
            });
        }
        updateState({
            filesToUpload: newFilesToUpload,
        });
    }, [filesToUpload, filesUploading, currentPage, updateState]);
    // Save operations
    const saveTo = useCallback((campaignId, newEditionTitle) => {
        if (!savingR) {
            if (filesUploading.length === 0) {
                setVariables('savingtrue');
                updateState({ saving: true });
                const currentEdition = _.cloneDeep(edition);
                const rasterToSave = {
                    block_count: totalBlockCount,
                    pages: raster,
                };
                currentEdition.raster = rasterToSave;
                currentEdition.pages = contentPages;
                currentEdition.shown = currentPage;
                currentEdition.marked = false;
                currentEdition.usedMedia = usedMedia;
                currentEdition.title = newEditionTitle;
                currentEdition.campaign = campaignId;
                currentEdition.template = edition.template.id;
                currentEdition.item = edition.item.id;
                currentEdition.action = 'copy';
                delete currentEdition.id;
                delete currentEdition.cdate;
                delete currentEdition.mdate;
                saveToR(currentEdition);
            }
            else {
                waitForSavingRef.current = setTimeout(() => {
                    saveTo(campaignId, newEditionTitle);
                }, 1000);
            }
        }
    }, [
        savingR,
        filesUploading,
        edition,
        totalBlockCount,
        raster,
        contentPages,
        currentPage,
        usedMedia,
        setVariables,
        saveToR,
        updateState,
    ]);
    const initTemplate = useCallback(() => {
        setVariables('savingtrue');
        updateState({ saving: true });
        const rasterToSave = {
            blockCount: totalBlockCount,
            pages: raster,
        };
        const contentToSave = {
            initialRaster: rasterToSave,
            initialPages: contentPages,
        };
        initTemplateR(templateSettings, contentToSave);
    }, [totalBlockCount, raster, contentPages, templateSettings, setVariables, initTemplateR, updateState]);
    const changePages = useCallback((e) => {
        const sourceIndex = parseInt(e.currentTarget.getAttribute('data-page') || '0', 10);
        const sourcePage = _.cloneDeep(contentPages[sourceIndex]);
        const sourceRaster = _.cloneDeep(raster[sourceIndex]);
        const targetIndex = parseInt(e.currentTarget.getAttribute('data-target') || '0', 10);
        const targetPage = _.cloneDeep(contentPages[targetIndex]);
        const targetRaster = _.cloneDeep(raster[targetIndex]);
        targetPage.page_number = sourceIndex + 1;
        sourcePage.page_number = targetIndex + 1;
        const newContentPages = [...contentPages];
        const newRaster = [...raster];
        newContentPages[sourceIndex] = targetPage;
        newContentPages[targetIndex] = sourcePage;
        newRaster[sourceIndex] = targetRaster;
        newRaster[targetIndex] = sourceRaster;
        setVariables('unsavedtrue');
        const newChanges = {
            text: messages.editor.page + targetPage.page_number + messages.editor.exchanged_with_page + sourcePage.page_number,
            action: 'add',
        };
        const newChangesR = _.cloneDeep(changesR);
        if (typeof newChangesR[0] === 'undefined') {
            newChangesR[0] = [];
        }
        const timestamp = Date.now();
        newChangesR[0][timestamp] = newChanges;
        setVariables('unsavedtrue');
        setChangesR(newChangesR);
        const newColorSettings = _.cloneDeep(colorSettings);
        const filteredColorSettings = _.filter(newColorSettings, (x) => x.page !== sourceIndex && x.page !== targetIndex);
        updateState({
            colorSettings: filteredColorSettings,
            contentPages: newContentPages,
            raster: newRaster,
            unsaved: true,
        });
    }, [contentPages, raster, colorSettings, changesR, messages, setVariables, setChangesR, updateState]);
    const showChangePageNumber = useCallback((i) => {
        updateState({ showChangePageNumberOptionsForPage: i, currentPage: i });
    }, [updateState]);
    const changePageNumbers = useCallback((e) => {
        var _a;
        const sourceIndex = parseInt(e.target.getAttribute('data-page'), 10);
        const targetIndex = parseInt(e.target.value, 10) - 1;
        // Validation checks
        const checkIsFirstPageAndFixed = (pageNumber) => pageNumber === parseInt(templateSettings === null || templateSettings === void 0 ? void 0 : templateSettings.first_page_number, 10) && (templateSettings === null || templateSettings === void 0 ? void 0 : templateSettings.first_page_fixed);
        const checkIsLastPageAndFixed = (pageNumber) => pageNumber === parseInt(templateSettings === null || templateSettings === void 0 ? void 0 : templateSettings.last_page_number, 10) && (templateSettings === null || templateSettings === void 0 ? void 0 : templateSettings.last_page_fixed);
        const getPageSettings = (pageNum) => templateSettings.pages.find((p) => parseInt(p.page_number, 10) === pageNum) ||
            templateSettings.pages.find((p) => parseInt(p.page_number, 10) === 0);
        if (sourceIndex === targetIndex)
            return doNotify(2, messages.change_page_number_notify.same_page);
        if (targetIndex < 0 || targetIndex >= pageAmount)
            return doNotify(2, messages.change_page_number_notify.out_of_range);
        if (((_a = getPageSettings(targetIndex + 1)) === null || _a === void 0 ? void 0 : _a.fixed) ||
            checkIsFirstPageAndFixed(targetIndex + 1) ||
            checkIsLastPageAndFixed(targetIndex + 1))
            return doNotify(2, messages.change_page_number_notify.fixed_page);
        updateState((prevState) => {
            const _contentPages = _.cloneDeep(prevState.contentPages);
            let _colorSettings = _.cloneDeep(prevState.colorSettings);
            const newRasterIndex = Array(_contentPages.length).fill(null);
            _.forEach(_contentPages, (contentPage) => {
                var _a, _b;
                const pageNum = contentPage.page_number;
                if (pageNum >= Math.min(sourceIndex, targetIndex) + 1 && pageNum <= Math.max(sourceIndex, targetIndex) + 1) {
                    if (pageNum === sourceIndex + 1) {
                        contentPage.page_number = targetIndex + 1;
                        _colorSettings = _.filter(_colorSettings, (x) => x.page !== targetIndex);
                    }
                    else if (!((_a = getPageSettings(pageNum)) === null || _a === void 0 ? void 0 : _a.fixed) &&
                        !checkIsFirstPageAndFixed(pageNum) &&
                        !checkIsLastPageAndFixed(pageNum)) {
                        let newPageNumber = sourceIndex < targetIndex ? pageNum - 1 : pageNum + 1;
                        // Make sure new page number is not a fixed page
                        while ((_b = getPageSettings(newPageNumber)) === null || _b === void 0 ? void 0 : _b.fixed)
                            newPageNumber += sourceIndex < targetIndex ? -1 : 1;
                        // skip all fixed pages and then set a new page number
                        contentPage.page_number = newPageNumber;
                        // update color settings - delete affected pages. New color settings are updated elsewhere when the pages are reloaded after the state changes
                        _colorSettings = _.filter(_colorSettings, (x) => x.page + 1 !== newPageNumber);
                    }
                }
                newRasterIndex[contentPage.page_number - 1] = raster[pageNum - 1];
            });
            return {
                colorSettings: _colorSettings,
                contentPages: _contentPages.sort((a, b) => a.page_number - b.page_number),
                raster: newRasterIndex,
                unsaved: true,
            };
        });
        const newChangesR = _.cloneDeep(changesR);
        if (!newChangesR[0])
            newChangesR[0] = [];
        newChangesR[0][Date.now()] = {
            text: `${messages.editor.page}${sourceIndex + 1} ${messages.editor.moved_to_page}${targetIndex + 1}`,
            action: 'add',
        };
        setChangesR(newChangesR);
        setVariables('unsavedtrue');
    }, [templateSettings, pageAmount, raster, changesR, messages, doNotify, setChangesR, setVariables, updateState]);
    const addPages = useCallback((e) => {
        const positionPage = parseInt(e.currentTarget.getAttribute('data-page') || '0', 10) + 1;
        const addStep = templateSettings.page_add_step;
        const newPageAmount = pageAmount + addStep;
        const newPages = [];
        const newPagesRaster = [];
        let pageSpace;
        const pageNumbersForInsertBlock = [];
        _.forEach(contentPages, (contentPage, i) => {
            var _a, _b;
            if (i === positionPage) {
                for (let j = 0; j < addStep; j++) {
                    pageNumbersForInsertBlock.push(i + j + 1);
                    newPages.push({
                        page_number: i + j + 1,
                        space_consumed: 0,
                        blocks: [],
                    });
                    pageSpace = templateSettings.pages[getPageNameIndex(i + j, templateSettings)].page_space;
                    const newSlots = [];
                    for (let slots = 0; slots < pageSpace; slots++) {
                        newSlots[slots] = '';
                    }
                    newPagesRaster[j] = newSlots;
                }
                contentPage.page_number = i + addStep + 1;
            }
            else if (i > positionPage) {
                contentPage.page_number = i + addStep + 1;
            }
            newPages.push(contentPage);
            if (positionPage === contentPages.length && i === contentPages.length - 1) {
                for (let j = 0; j < addStep; j++) {
                    pageNumbersForInsertBlock.push(i + j + 2);
                    newPages.push({
                        page_number: i + j + 2,
                        space_consumed: 0,
                        blocks: [],
                    });
                    pageSpace = templateSettings.pages[getPageNameIndex(i + j + 1, templateSettings)].page_space;
                    const newSlots = [];
                    for (let slots = 0; slots < pageSpace; slots++) {
                        newSlots[slots] = '';
                    }
                    newPagesRaster[j] = newSlots;
                }
            }
            if (newPages.length === newPageAmount) {
                const changedRaster = [...raster.slice(0, positionPage), ...newPagesRaster, ...raster.slice(positionPage)];
                setVariables('unsavedtrue');
                const newChanges = {
                    text: addStep + messages.editor.new_page_inserted + (positionPage + 1),
                    action: 'add',
                };
                const newChangesR = _.cloneDeep(changesR);
                if (typeof newChangesR[0] === 'undefined') {
                    newChangesR[0] = [];
                }
                const timestamp = Date.now();
                newChangesR[0][timestamp] = newChanges;
                setVariables('unsavedtrue');
                setChangesR(newChangesR);
                updateState({
                    pageAmount: newPageAmount,
                    contentPages: newPages,
                    currentPage: positionPage,
                    raster: changedRaster,
                    unsaved: true,
                    blockContainer: null,
                });
                // Handle sample pages
                // if samplePage declared start
                if (((_a = edition === null || edition === void 0 ? void 0 : edition.template) === null || _a === void 0 ? void 0 : _a.sample_page_number) > 0 || ((_b = edition === null || edition === void 0 ? void 0 : edition.template) === null || _b === void 0 ? void 0 : _b.sample_page_number_two) > 0) {
                    let blockIds;
                    let blockIndex;
                    const blockIndexNew = [];
                    let blockIndexTwo;
                    const blockIndexNewTwo = [];
                    const initialPages = templateSettings.initialized ? edition.template.initial_pages : contentPages;
                    for (let it = 0; it < initialPages[edition.template.sample_page_number - 1].blocks.length; it++) {
                        for (let xbc = 0; xbc < edition.template.template_block_category.length; xbc++) {
                            for (let xbcv = 0; xbcv < edition.template.template_block_category[xbc].variants.length; xbcv++) {
                                for (let xbcvb = 0; xbcvb < edition.template.template_block_category[xbc].variants[xbcv].blocks.length; xbcvb++) {
                                    if (edition.template.template_block_category[xbc].variants[xbcv].blocks[xbcvb].id ===
                                        initialPages[edition.template.sample_page_number - 1].blocks[it].template_id) {
                                        blockIndex = xbc + '.' + xbcv + '.' + xbcvb;
                                        blockIndexNew.push(blockIndex);
                                    }
                                }
                            }
                        }
                    }
                    if (edition.template.sample_page_number_two > 0) {
                        for (let it = 0; it < initialPages[edition.template.sample_page_number_two - 1].blocks.length; it++) {
                            for (let xbc = 0; xbc < edition.template.template_block_category.length; xbc++) {
                                for (let xbcv = 0; xbcv < edition.template.template_block_category[xbc].variants.length; xbcv++) {
                                    for (let xbcvb = 0; xbcvb < edition.template.template_block_category[xbc].variants[xbcv].blocks.length; xbcvb++) {
                                        if (edition.template.template_block_category[xbc].variants[xbcv].blocks[xbcvb].id ===
                                            initialPages[edition.template.sample_page_number_two - 1].blocks[it].template_id) {
                                            blockIndexTwo = xbc + '.' + xbcv + '.' + xbcvb;
                                            blockIndexNewTwo.push(blockIndexTwo);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    blockIds = 'noIds';
                    insertContentBlock(blockIds, blockIndexNew, pageNumbersForInsertBlock, 'addPage', blockIndexNewTwo, changedRaster, newPageAmount, newPages);
                }
            }
        });
    }, [
        contentPages,
        templateSettings,
        pageAmount,
        raster,
        changesR,
        edition,
        messages,
        setVariables,
        setChangesR,
        updateState,
        insertContentBlock,
    ]);
    const removePages = useCallback((e) => {
        // todo check for oversized blocks
        const positionPage = parseInt(e.currentTarget.getAttribute('data-page') || '0', 10);
        const addStep = templateSettings.page_add_step;
        const newPageAmount = pageAmount - addStep;
        const newPages = [];
        let pagesToDelete = '';
        for (let i = 1; i <= addStep; i++) {
            const page = positionPage + 1 + i;
            pagesToDelete += messages.page_to_delete + page;
            if (i < addStep) {
                pagesToDelete += ', ';
            }
        }
        const options = {
            title: messages.editor.delete_pages,
            message: addStep +
                ' ' +
                messages.editor.all_content_deleted +
                messages.pages_to_delete +
                '(' +
                pagesToDelete +
                ')',
            buttons: [
                {
                    label: messages.editor.yes_delete,
                    onClick: () => {
                        const startPage = positionPage + 1;
                        const endPage = positionPage + addStep;
                        let newColorSettings = _.cloneDeep(colorSettings);
                        // 1. Clean up the color information for the deleted pages.
                        newColorSettings = _.filter(newColorSettings, (x) => {
                            if (typeof x.page === 'number') {
                                return x.page < startPage || x.page > endPage;
                            }
                            return true;
                        });
                        // 2. Delete pages
                        _.forEach(contentPages, (contentPage, i) => {
                            if (i <= positionPage) {
                                // Pages located before the group being deleted will be retained unchanged.
                                newPages.push(contentPage);
                            }
                            else if (i > positionPage + addStep) {
                                // Pages located AFTER the group being deleted will be retained and renumbered.
                                contentPage.page_number = i - addStep + 1;
                                newPages.push(contentPage);
                            }
                            // Pages within the range (positionPage + 1 to positionPage + addStep) are skipped (deleted).
                            // The main logic for updating the state is executed once all pages have been processed
                            // and the number of new pages matches the expected result.
                            if (newPages.length === newPageAmount) {
                                const changedRaster = [
                                    ...raster.slice(0, positionPage + 1),
                                    ...raster.slice(positionPage + 1 + addStep),
                                ];
                                setVariables('unsavedtrue');
                                const newChanges = {
                                    text: addStep + messages.editor.pages_deleted + (positionPage + 1),
                                    action: 'remove',
                                };
                                const newChangesR = _.cloneDeep(changesR);
                                if (typeof newChangesR[0] === 'undefined') {
                                    newChangesR[0] = [];
                                }
                                const timestamp = Date.now();
                                newChangesR[0][timestamp] = newChanges;
                                setVariables('unsavedtrue');
                                setChangesR(newChangesR);
                                updateState({
                                    pageAmount: newPageAmount,
                                    contentPages: newPages,
                                    currentPage: positionPage,
                                    raster: changedRaster,
                                    unsaved: true,
                                    colorSettings: newColorSettings,
                                });
                            }
                        });
                    },
                },
                {
                    label: messages.editor.rather_not,
                    onClick: () => { },
                },
            ],
            childrenElement: () => _jsx("div", {}),
            closeOnEscape: true,
            closeOnClickOutside: true,
        };
        confirmAlert(options);
    }, [
        contentPages,
        templateSettings,
        pageAmount,
        raster,
        changesR,
        messages,
        setVariables,
        setChangesR,
        updateState,
        colorSettings,
    ]);
    const webPreview = useCallback(() => {
        const preview = window.open(window.location.protocol + '//' + window.location.hostname + '/de/website/' + edition.id, '_blank');
        preview === null || preview === void 0 ? void 0 : preview.focus();
    }, [edition.id]);
    const resetNavEntry = useCallback(() => {
        updateState({ navEntry: [] });
    }, [updateState]);
    const setActiveHeight = useCallback((height) => {
        if (activeHeight !== height) {
            updateState({ activeHeight: height });
        }
    }, [activeHeight, updateState]);
    const showTourF = () => {
        updateState({ showTour: true });
    };
    const closeTour = () => {
        updateState({ showTour: false });
    };
    const changeEditionTitle = useCallback((newTitle) => {
        setVariables('unsavedtrue');
        updateState({ editionTitle: newTitle, unsaved: true });
    }, [setVariables, updateState]);
    const changeEditionSettings = useCallback((newSettings) => {
        setVariables('unsavedtrue');
        updateState({ editionSettings: newSettings, unsaved: true });
    }, [setVariables, updateState]);
    const getCampaigns = useCallback(() => {
        let filters = '';
        if (may('ROLE_ROOT_EMPLOYEE', user.roles)) {
            filters = FILTERS.SAVE_TO_FOR_ROOT_EMPLOYEES;
        }
        getCampaignsR(filters);
    }, [user.roles, getCampaignsR]);
    const getTourSteps = useCallback(() => tourSteps(messages), [messages]);
    const checkDataPolicy = useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const responsible = ((_a = _.find(editionSettings, ['name', 'datenschutzverantwortlicher'])) === null || _a === void 0 ? void 0 : _a.value) || '';
        const companyAssociation = ((_b = _.find(editionSettings, ['name', 'datenschutzfirma'])) === null || _b === void 0 ? void 0 : _b.value) || '';
        const street = ((_c = _.find(editionSettings, ['name', 'datenschutzstrasse'])) === null || _c === void 0 ? void 0 : _c.value) || '';
        const zipCode = ((_d = _.find(editionSettings, ['name', 'datenschutzplz'])) === null || _d === void 0 ? void 0 : _d.value) || '';
        const city = ((_e = _.find(editionSettings, ['name', 'datenschutzort'])) === null || _e === void 0 ? void 0 : _e.value) || '';
        const email = ((_f = _.find(editionSettings, ['name', 'datenschutzmail'])) === null || _f === void 0 ? void 0 : _f.value) || '';
        const phoneNumber = ((_g = _.find(editionSettings, ['name', 'datenschutztelefon'])) === null || _g === void 0 ? void 0 : _g.value) || '';
        const dataProtectionAuthority = ((_h = _.find(editionSettings, ['name', 'datenschutzbehoerde'])) === null || _h === void 0 ? void 0 : _h.value) || '';
        return (responsible !== '' &&
            companyAssociation !== '' &&
            street !== '' &&
            zipCode !== '' &&
            city !== '' &&
            email !== '' &&
            phoneNumber !== '' &&
            dataProtectionAuthority !== '');
    }, [editionSettings]);
    const checkImpressum = useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        const responsibleForContent = ((_a = _.find(editionSettings, ['name', 'impressumverantwortlicher'])) === null || _a === void 0 ? void 0 : _a.value) || '';
        const companyAssociation = ((_b = _.find(editionSettings, ['name', 'impressumfirma'])) === null || _b === void 0 ? void 0 : _b.value) || '';
        const street = ((_c = _.find(editionSettings, ['name', 'impressumstrasse'])) === null || _c === void 0 ? void 0 : _c.value) || '';
        const zipCode = ((_d = _.find(editionSettings, ['name', 'impressumplz'])) === null || _d === void 0 ? void 0 : _d.value) || '';
        const city = ((_e = _.find(editionSettings, ['name', 'impressumort'])) === null || _e === void 0 ? void 0 : _e.value) || '';
        const email = ((_f = _.find(editionSettings, ['name', 'impressummail'])) === null || _f === void 0 ? void 0 : _f.value) || '';
        const phoneNumber = ((_g = _.find(editionSettings, ['name', 'impressumtelefon'])) === null || _g === void 0 ? void 0 : _g.value) || '';
        return (responsibleForContent !== '' &&
            companyAssociation !== '' &&
            street !== '' &&
            zipCode !== '' &&
            city !== '' &&
            email !== '' &&
            phoneNumber !== '');
    }, [editionSettings]);
    const showSettingsF = () => {
        updateState({ showSettings: true });
    };
    const closeSettingsF = () => {
        updateState({ showSettings: false });
    };
    const getDataPolicyWarning = useCallback((option) => {
        const options = {
            customUI: ({ onClose }) => {
                return (_jsxs("div", { className: "react-confirm-alert-body", children: [_jsx("h1", { children: messages.data_policy_info }), option === 'manual' ? (_jsx("p", { children: messages.fill_data_policy_before_save })) : (_jsx("p", { children: messages.fill_data_policy_before_autosave })), _jsxs("div", { className: "react-confirm-alert-button-group", style: { width: '100%', margin: '0 auto' }, children: [_jsxs(Button, { style: { marginRight: '0px', minWidth: '100%' }, onClick: () => {
                                        onClose();
                                        showSettingsF();
                                    }, variant: "light", children: [_jsx("i", { className: "far fa-cog" }), " ", _jsxs("span", { children: [" ", messages.editor.settings] })] }), _jsx(Button, { style: { margin: '0 auto', marginTop: '20px', width: '100px' }, variant: "primary", onClick: onClose, children: "OK" })] })] }));
            },
            childrenElement: () => _jsx("div", {}),
            closeOnEscape: true,
            closeOnClickOutside: true,
        };
        confirmAlert(options);
    }, [messages, showSettingsF]);
    // Color settings functions
    const setSelectedColor = useCallback((blockId, colorId, currentPage, info, sectionTag, pageTag, blockContainerId, stageTag, attributeName) => {
        updateState((prevState) => {
            const _colorSettings = _cloneDeep(prevState.colorSettings);
            const _currentPage = 'page_' + (currentPage + 1);
            const existingBlockIndex = _.findIndex(_colorSettings, (setting) => setting.id === blockId && setting.name === attributeName && setting.blockContainer === blockContainerId);
            const existingPageIndex = _.findIndex(_colorSettings, (setting) => setting.id === _currentPage && setting.activeSection === blockId && setting.name === attributeName);
            const existingStageIndex = _.findIndex(_colorSettings, (setting) => setting.id === 'stage' && setting.activeSection === blockId && setting.name === attributeName);
            if (pageTag) {
                info = 'page';
                const colorPageSetting = {
                    id: _currentPage,
                    color: colorId,
                    type: info,
                    page: currentPage,
                    activeSection: blockId,
                    blockContainer: blockContainerId,
                    name: attributeName,
                };
                if (existingPageIndex !== -1) {
                    _colorSettings[existingPageIndex] = colorPageSetting; // replace old entry
                }
                else {
                    _colorSettings.push(colorPageSetting); // add new entry
                }
            }
            if (sectionTag) {
                info = 'section';
                const colorBlockSetting = {
                    id: blockId,
                    color: colorId,
                    type: info,
                    page: currentPage,
                    activeSection: blockId,
                    blockContainer: blockContainerId,
                    name: attributeName,
                };
                if (existingBlockIndex !== -1) {
                    _colorSettings[existingBlockIndex] = colorBlockSetting; // replace old entry
                }
                else {
                    _colorSettings.push(colorBlockSetting); // add new entry
                }
            }
            if (stageTag) {
                info = 'stage';
                const colorStageSetting = {
                    id: 'stage',
                    color: colorId,
                    type: info,
                    page: currentPage,
                    activeSection: blockId,
                    blockContainer: blockContainerId,
                    name: attributeName,
                };
                if (existingStageIndex !== -1) {
                    _colorSettings[existingStageIndex] = colorStageSetting;
                }
                else {
                    _colorSettings.push(colorStageSetting);
                }
            }
            return { colorSettings: _colorSettings };
        });
    }, [updateState]);
    const deleteSelectedColor = useCallback((blockId, blockContainerId) => {
        updateState((prevState) => {
            const { colorSettings } = prevState;
            let _colorSettings = _.cloneDeep(colorSettings);
            // Step 1: Find and delete color of section or page on page or container
            // x.activeSection !== blockId -> remove default block
            // x.blockContainer !== blockId -> remove container block -> all elements within
            // x.blockContainer !== blockContainer -> remove specific block within container
            _colorSettings = _.filter(_colorSettings, (x) => x.activeSection !== blockId && x.blockContainer !== blockId && x.blockContainer !== blockContainerId);
            return { colorSettings: _colorSettings };
        });
    }, [updateState]);
    const getColorSettings = useCallback((id, blockContainerId) => {
        let sectionColorClasses = '';
        const filteredSectionColorSettings = _.filter(colorSettings, (setting) => setting.id === id && setting.blockContainer === blockContainerId);
        _.forEach(filteredSectionColorSettings, (filteredSectionColorSetting) => {
            sectionColorClasses = sectionColorClasses + ' ' + filteredSectionColorSetting.color;
        });
        return sectionColorClasses;
    }, [colorSettings]);
    const setFontSizeSettings = useCallback((blockId, fontSizeClass) => {
        updateState((prevState) => {
            const _fontSizeSettings = _cloneDeep(prevState.fontSizeSettings);
            _fontSizeSettings[blockId] = fontSizeClass;
            return { fontSizeSettings: _fontSizeSettings };
        });
    }, [updateState]);
    // render part from original
    const emergency = true;
    let lightAndDarkModeClass = 'light-mode';
    if (darkModeSettings.username === user.username && darkModeSettings.isDarkMode) {
        lightAndDarkModeClass = 'dark-mode';
    }
    const deviceType = getDeviceType();
    // Calculate various values needed for rendering
    const pageNames = [];
    const pageFinder = [];
    const pagePreview = [];
    const handledOversizeIds = [];
    let errorsCount = 0;
    let errorsText = '';
    let paddingStyle = '';
    const pagesAmount = contentPages.length;
    const ratio = templateSettings.height / templateSettings.width;
    let previewStyles = {
        height: (100 * ratio).toFixed(0) + 'px',
    };
    let imageExport = false;
    if (templateSettings.export_type.value === '000000000000000000000001') {
        imageExport = true;
    }
    let website = false;
    if (templateSettings.export_type.value === '000000000000000000000003') {
        website = true;
    }
    let videoExport = false;
    if (templateSettings.export_type.value === '000000000000000000000004') {
        videoExport = true;
    }
    const hidePreview = ((_c = edition === null || edition === void 0 ? void 0 : edition.item) === null || _c === void 0 ? void 0 : _c.hide_preview) === true ? (_d = edition === null || edition === void 0 ? void 0 : edition.item) === null || _d === void 0 ? void 0 : _d.hide_preview : false;
    // Calculate page sizes and paddings
    let pageSizeIndex = _.findIndex(templateSettings.page_sizes, ['pages_amount', contentPages.length]);
    if (pageSizeIndex < 0) {
        // no sizes for this page, let check if we have a default entry
        pageSizeIndex = _.findIndex(templateSettings.page_sizes, ['pages_amount', 0]);
        if (pageSizeIndex < 0) {
            // also no default entry, so give the user a hint
            alert(messages.editor.no_page_definitions_found);
        }
    }
    const pageWidths = ((_f = (_e = templateSettings.page_sizes[pageSizeIndex]) === null || _e === void 0 ? void 0 : _e.page_widths) === null || _f === void 0 ? void 0 : _f.split(',')) || [];
    const pageHeights = ((_h = (_g = templateSettings.page_sizes[pageSizeIndex]) === null || _g === void 0 ? void 0 : _g.page_heights) === null || _h === void 0 ? void 0 : _h.split(',')) || [];
    const topPaddings = ((_k = (_j = templateSettings.page_sizes[pageSizeIndex]) === null || _j === void 0 ? void 0 : _j.top_paddings) === null || _k === void 0 ? void 0 : _k.split(',')) || [];
    const rightPaddings = ((_m = (_l = templateSettings.page_sizes[pageSizeIndex]) === null || _l === void 0 ? void 0 : _l.right_paddings) === null || _m === void 0 ? void 0 : _m.split(',')) || [];
    const bottomPaddings = ((_p = (_o = templateSettings.page_sizes[pageSizeIndex]) === null || _o === void 0 ? void 0 : _o.bottom_paddings) === null || _p === void 0 ? void 0 : _p.split(',')) || [];
    const leftPaddings = ((_r = (_q = templateSettings.page_sizes[pageSizeIndex]) === null || _q === void 0 ? void 0 : _q.left_paddings) === null || _r === void 0 ? void 0 : _r.split(',')) || [];
    let lastPageNumber = templateSettings.last_page_number;
    if (lastPageNumber === 'last') {
        lastPageNumber = pagesAmount;
    }
    // Iterate through each page
    _.forEach(contentPages, (contentPage, i) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let pageFinderStyle = '';
        let pageActive = '';
        let previewClass = 'pagePreview ';
        let pageUpDisable = false;
        let pageDownDisable = false;
        let pageAddDisable = false;
        let pageSubDisable = false;
        let locked = '';
        let endlessIcon = '';
        const { page_number: pageNumber } = contentPage;
        let changePageNumberDisable = false;
        // Page formatting and positioning logic
        if ((templateSettings.format.divide_pages === 'half' && pagesAmount / 2 === i) ||
            (templateSettings.format.divide_pages === 'single' && i > 0) ||
            (templateSettings.format.divide_pages === 'double' &&
                templateSettings.format.order_pages !== 'first-last-single' &&
                i % 2 === 0 &&
                i > 0) ||
            (templateSettings.format.order_pages === 'first-last-single' &&
                (i === 1 || i + 1 === pagesAmount || i % 2 !== 0)) ||
            (templateSettings.format.divide_pages === 'double-single' && (i === 2 || i > 3))) {
            const sepClass = 'sep_' + templateSettings.format.divide_pages + ' ' + templateSettings.format.order_pages;
            const sepKey = `${sepClass}_${pageNumber}`;
            if (templateSettings.format.order_pages === 'down') {
                pageFinder.unshift(_jsx("span", { className: sepClass, children: "\u00A0" }, sepKey));
            }
            else {
                pageFinder.push(_jsx("span", { className: sepClass, children: "\u00A0" }, sepKey));
            }
            pageNames.push(_jsx(Dropdown.Item, {}, `MenuItem1_${pageNumber}`));
            pageFinderStyle += ` first`;
        }
        // Additional page formatting conditions
        if (pagesAmount / 2 === i + 1) {
            if (templateSettings.format.order_pages === 'down-up') {
                pageFinderStyle += ` first`;
            }
            else if (templateSettings.format.divide_pages === 'half') {
                pageFinderStyle += ` last`;
            }
        }
        if (pagesAmount === i + 1) {
            if (templateSettings.format.order_pages === 'down') {
                pageFinderStyle += ` first`;
            }
            else {
                pageFinderStyle += ` last`;
            }
        }
        if (i === 0) {
            if (templateSettings.format.order_pages === 'down-up' || templateSettings.format.order_pages === 'down') {
                pageFinderStyle += ` last`;
            }
            else {
                pageFinderStyle += ` first`;
            }
        }
        if (templateSettings.format.divide_pages === 'single' ||
            (templateSettings.format.order_pages === 'first-last-single' && (i === 0 || i === pagesAmount))) {
            if (!pageFinderStyle.includes('first'))
                pageFinderStyle += ` first`;
            if (!pageFinderStyle.includes('last'))
                pageFinderStyle += ` last`;
        }
        // Double page formatting
        if (templateSettings.format.divide_pages === 'double') {
            if (templateSettings.format.order_pages === 'down') {
                pageFinderStyle = i % 2 === 0 ? ` last` : ` first`;
            }
            else if (templateSettings.format.order_pages === 'first-last-single') {
                if (i === 0)
                    pageFinderStyle = `first last`;
                else if (i + 1 === pagesAmount)
                    pageFinderStyle = `last first`;
                else if (i % 2 !== 0)
                    pageFinderStyle = ` first`;
                else
                    pageFinderStyle = ` last`;
            }
            else {
                pageFinderStyle = i % 2 === 0 ? ` first` : ` last`;
                if (templateSettings.format.order_pages === 'firstDown-up') {
                    if (i === 0) {
                        pageFinderStyle = ` last`;
                    }
                    else if (i === 1) {
                        pageFinderStyle = ` first`;
                    }
                }
            }
        }
        if (templateSettings.format.divide_pages === 'double-single') {
            if (!pageFinderStyle.includes('first') && (i === 1 || i === 2)) {
                pageFinderStyle = ` first`;
            }
            if (!pageFinderStyle.includes('last') && (i === 0 || i === 3)) {
                pageFinderStyle = ` last`;
            }
            else if (i > 3) {
                pageFinderStyle = `first last`;
            }
        }
        if (i === currentPage) {
            pageFinderStyle += ` active`;
            pageActive = 'active';
        }
        // Add page to pageFinder
        if ((templateSettings.format.order_pages === 'down-up' && i < pagesAmount / 2) ||
            templateSettings.format.order_pages === 'down' ||
            (templateSettings.format.order_pages === 'firstDown-up' && i === 1) ||
            (templateSettings.format.order_pages === 'double-firstDown' && i === 1)) {
            pageFinder.unshift(_jsx("span", { className: pageFinderStyle, onClick: setCurrentPage, children: pageNumber }, 'pageFinderStyleDown' + i));
        }
        else {
            pageFinder.push(_jsx("span", { className: pageFinderStyle, onClick: setCurrentPage, children: pageNumber }, 'pageFinderStyle' + i));
        }
        previewClass += pageActive;
        const pageNameIndex = getPageNameIndex(i, templateSettings, pagesAmount);
        // Calculate paddings
        const paddingLeft = ((_a = templateSettings.pages[pageNameIndex]) === null || _a === void 0 ? void 0 : _a.padding_left) !== null &&
            ((_b = templateSettings.pages[pageNameIndex]) === null || _b === void 0 ? void 0 : _b.padding_left) !== undefined
            ? [templateSettings.pages[pageNameIndex].padding_left]
            : leftPaddings.length > 0
                ? parseFloat(leftPaddings[i] ? leftPaddings[i] : leftPaddings[0])
                : null;
        const paddingRight = ((_c = templateSettings.pages[pageNameIndex]) === null || _c === void 0 ? void 0 : _c.padding_right) !== null &&
            ((_d = templateSettings.pages[pageNameIndex]) === null || _d === void 0 ? void 0 : _d.padding_right) !== undefined
            ? [templateSettings.pages[pageNameIndex].padding_right]
            : rightPaddings.length > 0
                ? parseFloat(rightPaddings[i] ? rightPaddings[i] : rightPaddings[0])
                : null;
        const endless = !!templateSettings.pages[pageNameIndex].endless;
        // Build padding styles
        if (paddingLeft) {
            paddingStyle += `.seite_${i + 1} article.typesetting{padding-left: ${paddingLeft}px}`;
        }
        if (paddingRight) {
            paddingStyle += `.seite_${i + 1} article.typesetting{padding-right: ${paddingRight}px}`;
        }
        // Page preview styles
        let pagePreviewStyles = {
            width: templateSettings.width + 'px',
            height: templateSettings.height + 'px',
            transform: `scale(${100 / templateSettings.width})`,
            transformOrigin: 'top left',
        };
        if (website || endless) {
            pagePreviewStyles = {
                width: templateSettings.width + 'px',
                minHeight: templateSettings.height + 'px',
                height: 'auto',
                transform: `scale(${100 / templateSettings.width})`,
                transformOrigin: 'top left',
            };
            previewStyles = {
                height: activeHeight * (100 / templateSettings.width) + 'px',
                minHeight: (100 * ratio).toFixed(0) + 'px',
            };
        }
        const pageSpace = templateSettings.pages[pageNameIndex].page_space;
        // Add page to pageNames dropdown
        pageNames.push(_jsx(Dropdown.Item, { className: pageActive, eventKey: pageNumber, children: getNameInCurrentLanguage(templateSettings.pages[pageNameIndex].name, appIntl) }, `MenuItem2_${pageNumber}`));
        // Page navigation buttons
        const pageButtons = [];
        // Calculate move up/down restrictions
        let checkMoveUp = false;
        let moveUpBy = 1;
        for (let x = i - 1; x >= 0; x--) {
            const pageNameIndexForIt = getPageNameIndex(x, templateSettings, pagesAmount);
            if (templateSettings.pages[pageNameIndexForIt] && templateSettings.pages[pageNameIndexForIt].fixed === false) {
                checkMoveUp = true;
                moveUpBy = i - x;
                break;
            }
        }
        let checkMoveDown = false;
        let moveDownBy = 1;
        let checkAddAndRemovePage = true;
        for (let x = i + 1; x <= pagesAmount; x++) {
            const pageNameIndexForIt = getPageNameIndex(x, templateSettings, pagesAmount);
            if (templateSettings.pages[pageNameIndexForIt] && templateSettings.pages[pageNameIndexForIt].fixed === false) {
                checkMoveDown = true;
                moveDownBy = x - i;
                break;
            }
        }
        const counterDown = i + 1;
        for (let y = counterDown; y <= pagesAmount; y++) {
            const pageNameIndexForIt2 = getPageNameIndex(y, templateSettings, pagesAmount);
            if (templateSettings.pages[pageNameIndexForIt2] && templateSettings.pages[pageNameIndexForIt2].fixed === true) {
                checkAddAndRemovePage = false;
                y = pagesAmount + 1;
            }
        }
        // Disable conditions for page up button
        if ((templateSettings.last_page_fixed && i === parseInt(lastPageNumber.toString(), 10) - 1) ||
            (templateSettings.last_page_fixed && i === parseInt(lastPageNumber.toString(), 10)) ||
            (templateSettings.first_page_fixed && i === parseInt(templateSettings.first_page_number, 10) - 1) ||
            (templateSettings.first_page_fixed && i === parseInt(templateSettings.first_page_number, 10)) ||
            i === 0 ||
            templateSettings.pages[pageNameIndex].fixed === true ||
            checkMoveUp === false) {
            pageUpDisable = true;
        }
        if ((templateSettings.last_page_fixed && i === parseInt(lastPageNumber.toString(), 10) - 1) ||
            (templateSettings.first_page_fixed && i === parseInt(templateSettings.first_page_number, 10) - 1) ||
            templateSettings.pages[pageNameIndex].fixed === true) {
            changePageNumberDisable = true;
        }
        const targetUp = i - moveUpBy;
        pageButtons.push(_jsx(Button, { onClick: changePages, "data-page": i, disabled: pageUpDisable, "data-target": targetUp, "data-tooltip-content": messages.editor.by + moveUpBy + messages.editor.move_up, "data-tooltip-id": "right", variant: "light", children: _jsx("i", { "data-page": i, "data-target": targetUp, className: "far fa-angle-up" }) }, "ButtonPageUp"));
        // Disable conditions for page down button
        if ((templateSettings.first_page_fixed && i === parseInt(templateSettings.first_page_number, 10) - 1) ||
            (templateSettings.last_page_fixed && i === parseInt(lastPageNumber.toString(), 10) - 1) ||
            (templateSettings.last_page_fixed && i === parseInt(lastPageNumber.toString(), 10) - 2) ||
            i === pageAmount - 1 ||
            templateSettings.pages[pageNameIndex].fixed === true ||
            checkMoveDown === false) {
            pageDownDisable = true;
        }
        if ((templateSettings.first_page_fixed && i === templateSettings.first_page_number - 1) ||
            (templateSettings.last_page_fixed && i === parseInt(lastPageNumber.toString(), 10) - 1) ||
            templateSettings.pages[pageNameIndex].fixed === true) {
            locked = _jsx("i", { className: "fa fa-lock", "data-tooltip-content": messages.editor.side_position_fixed, "data-tooltip-id": "right" });
        }
        if (endless) {
            endlessIcon = _jsx("i", { className: "fa fa-infinity", "data-tooltip-content": messages.editor.generated_in_pdf, "data-tooltip-id": "right" });
        }
        const targetDown = i + moveDownBy;
        pageButtons.push(_jsx(Button, { onClick: changePages, "data-page": i, disabled: pageDownDisable, "data-target": targetDown, "data-tooltip-content": messages.editor.by + moveDownBy + messages.editor.move_down, "data-tooltip-id": "right", variant: "light", children: _jsx("i", { "data-page": i, "data-target": targetDown, className: "far fa-angle-down" }) }, "ButtonPageDown"));
        // Block thumbnails rendering
        const blockThumb = [];
        const paddingTop = ((_e = templateSettings.pages[pageNameIndex]) === null || _e === void 0 ? void 0 : _e.padding_top) !== null &&
            ((_f = templateSettings.pages[pageNameIndex]) === null || _f === void 0 ? void 0 : _f.padding_top) !== undefined
            ? parseFloat(templateSettings.pages[pageNameIndex].padding_top)
            : topPaddings.length > 0
                ? parseFloat(topPaddings[i] ? topPaddings[i] : topPaddings[0])
                : 0;
        const paddingBottom = ((_g = templateSettings.pages[pageNameIndex]) === null || _g === void 0 ? void 0 : _g.padding_bottom) !== null &&
            ((_h = templateSettings.pages[pageNameIndex]) === null || _h === void 0 ? void 0 : _h.padding_bottom) !== undefined
            ? parseFloat(templateSettings.pages[pageNameIndex].padding_bottom)
            : bottomPaddings.length > 0
                ? parseFloat(bottomPaddings[i] ? bottomPaddings[i] : bottomPaddings[0])
                : 0;
        const rasterV = Math.floor((templateSettings.height - paddingTop - paddingBottom) / templateSettings.pages[pageNameIndex].page_space);
        // Render blocks for this page
        if (contentPage.blocks.length > 0) {
            _.forEach(contentPage.blocks, (block, index) => {
                var _a, _b;
                const sectionClassPre = block.template ? block.template.match(/(?:data-section=").*?(?=\s*")/gm) : [''];
                const sectionClass = sectionClassPre ? ' ' + sectionClassPre[0].replace('data-section="', '') : '';
                let offsetTop = block.top;
                let bottomClass = '';
                const blockHeight = rasterV * block.page_space_needed;
                if (offsetTop === -1 || offsetTop === null || typeof offsetTop === 'undefined') {
                    offsetTop = getBlockTopFromRaster(raster, i, block.id);
                    offsetTop = offsetTop < 0 ? 0 : offsetTop;
                }
                const vPos = paddingTop + offsetTop * rasterV;
                const verticalPosition = {
                    top: vPos + 'px',
                    height: blockHeight + 'px',
                };
                if (block.bottom) {
                    verticalPosition.bottom = block.bottom + 'px';
                    bottomClass = ' page-bottom';
                }
                let multiplePagesBlockClass = '';
                let containerClass = '';
                if (block.container) {
                    containerClass = ' block-container';
                }
                let innerClass = '';
                if (block.inline_block) {
                    innerClass = ' inline-block col-section';
                }
                // Handle oversized blocks
                if (typeof block.oversize !== 'undefined' && block.oversize !== null && block.oversize !== 0) {
                    multiplePagesBlockClass = ' page-span-' + block.oversize.toString() + ' ' + block.oversize_position;
                    if (handledOversizeIds.findIndex((element) => element === block.oversizeId) === -1) {
                        const copyBlockIndex = contentPages[block.links_to].blocks.findIndex((element) => element.id === block.id);
                        if (contentPages[block.links_to].blocks[copyBlockIndex].params !== block.params) {
                            contentPages[block.links_to].blocks[copyBlockIndex].params = block.params;
                        }
                        handledOversizeIds.push(block.id);
                    }
                }
                let heightClass = '';
                if (block && block.page_space_needed) {
                    heightClass = ' height_' + block.page_space_needed;
                }
                const positionX = block.position_x;
                const positionY = block.position_y;
                // Apply color settings
                let sectionColorClasses = '';
                const filteredSectionColorSettings = _.filter(colorSettings, (setting) => setting.id === (block === null || block === void 0 ? void 0 : block.id));
                _.forEach(filteredSectionColorSettings, (filteredSectionColorSetting) => {
                    sectionColorClasses = sectionColorClasses + ' ' + filteredSectionColorSetting.color;
                });
                // Apply font size settings
                const sectionFontSize = ' ' + ((_a = fontSizeSettings[block === null || block === void 0 ? void 0 : block.id]) !== null && _a !== void 0 ? _a : '') + ' ';
                // Create block thumbnail
                blockThumb.push(_jsx("section", { "data-id": block.id, style: verticalPosition, className: multiplePagesBlockClass +
                        heightClass +
                        containerClass +
                        bottomClass +
                        innerClass +
                        sectionClass +
                        sectionColorClasses +
                        sectionFontSize, children: block.template && (block.template.includes('draggable') || block.template.includes('allowdraganddrop')) ? (_jsx("div", { className: "react-draggable", style: { transform: 'translate(' + positionX + 'px, ' + positionY + 'px)' }, children: _jsx(PreviewBlockFTs, { data: block, index: i + '.' + index, rasterV: rasterV, setSelectedColor: setSelectedColor, currentPage: i, updateParam: updateParam, getColorSettings: getColorSettings, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, updateInnerBlock: updateInnerBlock, usedMedia: usedMedia, appIntl: appIntl, imageUpload: uploadImage, colorSettings: colorSettings, updateBlocksState: updateBlocksState, settings: templateSettings }, i + '.' + index) })) : (_jsx(PreviewBlockFTs, { data: block, index: i + '.' + index, rasterV: rasterV, setSelectedColor: setSelectedColor, currentPage: i, updateParam: updateParam, getColorSettings: getColorSettings, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, updateInnerBlock: updateInnerBlock, usedMedia: usedMedia, appIntl: appIntl, imageUpload: uploadImage, colorSettings: colorSettings, updateBlocksState: updateBlocksState, settings: templateSettings }, i + '.' + index)) }, 'prev_bl_' + block.id));
                // Error handling for block parameters
                _.forEach(block.params, (blockParams) => {
                    if (blockParams.errors && blockParams.errors.overflow === true) {
                        errorsCount++;
                        errorsText += messages.editor.page + ' ' + pageNumber + ': ' + messages.editor.text_overflow + ' - ';
                    }
                    if (blockParams.errors && blockParams.errors.resolution_warning === true) {
                        errorsCount++;
                        errorsText += messages.editor.page + ' ' + pageNumber + ': ' + messages.editor.resolution_too_low + ' - ';
                    }
                });
                // Error handling for block container parameters
                _.forEach(block.blocks, (blockContainer) => {
                    _.forEach(blockContainer.params, (blockContainerParams) => {
                        if (blockContainerParams.errors && blockContainerParams.errors.overflow === true) {
                            errorsCount++;
                            errorsText += messages.editor.page + ' ' + pageNumber + ': ' + messages.editor.text_overflow + ' - ';
                        }
                        if (blockContainerParams.errors && blockContainerParams.errors.resolution_warning === true) {
                            errorsCount++;
                            errorsText += messages.editor.page + ' ' + pageNumber + ': ' + messages.editor.text_overflow + ' - ';
                        }
                    });
                });
                if (block.errors && block.errors.default_image) {
                    errorsCount++;
                    errorsText += `${messages.editor.page} ${pageNumber}: ${messages.editor.sample_picture_found} - '`;
                }
                if (block.errors && ((_b = block.errors) === null || _b === void 0 ? void 0 : _b.resolution_warning)) {
                    errorsCount++;
                    errorsText += `${messages.editor.page} ${pageNumber}: ${messages.editor.resolution_too_low} - `;
                }
            });
        }
        // Add page edit controls
        pagePreview.push(_jsx("div", { className: "pageEdit", children: _jsx(ButtonGroup, { size: "sm", vertical: true, children: pageButtons }) }, 'pagePreview_pageEdit' + i));
        const previewIndex = `page-preview-${i}`;
        const evenOdd = (i + 1) % 2 === 0 ? ' even' : ' odd';
        const _page = 'page_' + (i * 1 + 1);
        // Apply page color settings
        let pageColorClasses = '';
        const filteredColorSettings = _.filter(colorSettings, (setting) => setting.id === _page);
        _.forEach(filteredColorSettings, (filteredColorSetting) => {
            pageColorClasses = pageColorClasses + ' ' + filteredColorSetting.color;
        });
        // Add page preview
        pagePreview.push(_jsxs("div", { id: previewIndex, className: previewClass + ' previewPage', style: previewStyles, children: [_jsx("a", { "data-page": i, onClick: selectPage }), _jsx("div", { className: 'page seite_' + (i + 1) + ' anzahl_' + pageAmount + evenOdd + pageColorClasses, style: pagePreviewStyles, children: blockThumb })] }, 'pagePreview_previewPage' + i));
        // Add page number edit options
        pagePreview.push(_jsx("div", { className: "pageNumberEditOption", children: _jsx(ButtonGroup, { size: "sm", vertical: true, children: _jsx(Button, { onClick: () => showChangePageNumber(i), disabled: changePageNumberDisable, "data-tooltip-content": messages.change_page_options, "data-tooltip-id": "right", children: _jsx("i", { className: "fa-duotone fa-thin fa-gear" }) }) }) }, 'pagePreview_showEditOptions_' + i));
        // Show page number input if this page is selected for editing
        if (i === showChangePageNumberOptionsForPage) {
            pagePreview.push(_jsx("div", { className: "pageEditNumber", children: _jsx(ButtonGroup, { size: "sm", vertical: true, children: _jsx(FormInputConfirm, { name: "pageNumber", type: "number", label: "", value: i + 1, "data-page": i, onChange: changePageNumbers, disabled: changePageNumberDisable }) }) }, 'pagePreview_pageEditNumber_' + i));
        }
        // Add page name
        pagePreview.push(_jsxs("div", { className: "pageName", style: { borderBottom: '1px solid #999' }, children: [_jsxs("b", { children: [pageNumber, ":"] }), getNameInCurrentLanguage(templateSettings.pages[pageNameIndex].name, appIntl), " ", locked, " ", endlessIcon] }, `pagePreview_pageName_${pageNumber}`));
        // Add page add/remove buttons
        if (i < pageAmount - 1 ||
            (i === pageAmount - 1 &&
                (templateSettings.last_page_number !== 'last' || !templateSettings.last_page_fixed) &&
                pageAmount < templateSettings.page_max_amount) ||
            (pageAmount === 1 && templateSettings.page_max_amount > 1)) {
            if (templateSettings.last_page_fixed &&
                i + templateSettings.page_add_step === parseInt(lastPageNumber.toString(), 10) - 1) {
                pageSubDisable = true;
            }
            if (templateSettings.page_max_amount === pageAmount ||
                templateSettings.page_add_step === 0 ||
                (lastPageNumber === pageAmount && lastPageNumber === i + 1) ||
                !checkAddAndRemovePage) {
                pageAddDisable = true;
            }
            if (templateSettings.page_add_step === 0 ||
                templateSettings.page_min_amount === pageAmount ||
                pageAmount - templateSettings.page_add_step < templateSettings.page_min_amount ||
                i + 1 === pageAmount ||
                !checkAddAndRemovePage ||
                (templateSettings.page_add_step > 1 && (i + 1) % templateSettings.page_add_step !== 0)) {
                pageSubDisable = true;
            }
            const titleAdd = templateSettings.page_add_step + messages.editor.add_page;
            const titleSub = templateSettings.page_add_step + messages.editor.remove_page;
            pagePreview.push(_jsx("div", { className: "pageAddSub", children: _jsxs(ButtonGroup, { size: "sm", children: [_jsxs(Button, { "data-tooltip-content": titleAdd, "data-tooltip-id": "right", disabled: pageAddDisable, "data-page": i, onClick: addPages, variant: "light", children: [_jsx("i", { className: "far fa-plus", "data-page": i }), " ", templateSettings.page_add_step] }, "ButtonAddPage"), _jsxs(Button, { "data-tooltip-content": titleSub, "data-tooltip-id": "right", disabled: pageSubDisable, "data-page": i, onClick: removePages, variant: "light", children: [_jsx("i", { className: "far fa-minus", "data-page": i }), " ", templateSettings.page_add_step] }, "ButtonRemovePage")] }) }, 'pageAddSub' + i));
        }
    });
    return (_jsxs(TourProvider, { steps: getTourSteps(), onClickClose: ({ setIsOpen }) => {
            setIsOpen(false);
            updateState({ showTour: false });
        }, children: [_jsx(TourTrigger, { showTour: showTour }), _jsxs("div", { className: `cc-editor ${lightAndDarkModeClass}`, children: [activeForms.allowEdit && !activeForms.requestFormReleasePending ? (_jsx(_Fragment, {})) : !may('ROLE_ROOT_EMPLOYEE', user.roles) ? (_jsx("div", { className: "blockedByOverflow", children: _jsxs("div", { className: "blockedByOverflowContent", children: [user.username === activeForms.blockedBy ? (_jsx("p", { children: messages.editor.already_edited_in_another_tab })) : (_jsx("p", { children: messages.already_edited_by_another_user })), !!activeForms.blockedBy && (_jsx("div", { className: "pull-right m-r-10", children: _jsx(ActiveFormsToolbar, { formStatus: "", entityChanged: "", formType: "editor", formId: editionId, emergency: emergency }) }))] }) })) : (_jsx(_Fragment, {})), unsavedR && _jsx(Beforeunload, { onBeforeunload: () => messages.editor.unsaved_changes }), paddingStyle.length > 0 ? _jsx(EditorApplyStylesFTs, { styles: paddingStyle }) : null, _jsx(EditorApplyStylesFTs, { styles: globalCss }), ((_s = projectConfig === null || projectConfig === void 0 ? void 0 : projectConfig.data) === null || _s === void 0 ? void 0 : _s.css) ? _jsx(EditorApplyStylesFTs, { styles: (_t = projectConfig === null || projectConfig === void 0 ? void 0 : projectConfig.data) === null || _t === void 0 ? void 0 : _t.css }) : null, item.css ? _jsx(EditorApplyStylesFTs, { styles: item.css }) : null, item.vendor ? _jsx(EditorApplyStylesFTs, { styles: item.vendor.css }) : null, templateSettings.target ? _jsx(EditorApplyStylesFTs, { styles: templateSettings.target.css }) : null, _jsx(EditorApplyStylesFTs, { styles: templateSettings.css }), _jsxs(EditorSettingsContext.Provider, { value: {
                            showSettingsF,
                            closeSettingsF,
                        }, children: [_jsx(EditorToolbarFTs, { user: user, imageExport: imageExport, website: website, videoExport: videoExport, editionId: editionId, currentPage: currentPage, pageAmount: pageAmount, updateCurrentPage: updateCurrentPage, pageNames: pageNames, saveContent: saveContent, init: templateSettings.initialized, initTemplate: initTemplate, savingR: savingR, saveTo: saveTo, unsavedR: unsavedR, campaign: campaign, editionTitle: editionTitle, itemName: itemName, changeEditionTitle: changeEditionTitle, campaignOptionsR: campaignOptionsR, getCampaigns: getCampaigns, edition: edition, showWebPreview: webPreview, history: history, editionSettings: editionSettings, changeEditionSettings: changeEditionSettings, printingR: printingR, previewingR: previewingR, accessibleR: accessibleR, exportingR: exportingR, placeholder: templateSettings.placeholder, checkDataPolicy: checkDataPolicy, checkImpressum: checkImpressum, hidePreview: hidePreview, getDataPolicyWarning: getDataPolicyWarning, showSettings: showSettings, showSettingsF: showSettingsF, closeSettingsF: closeSettingsF, templateSettingsId: templateSettings.id, accessibilityPDF: templateSettings === null || templateSettings === void 0 ? void 0 : templateSettings.pdf_profile_ua1, bookmarks: templateSettings === null || templateSettings === void 0 ? void 0 : templateSettings.bookmarks, setDarkMode: setDarkMode, darkModeSettings: darkModeSettings }), _jsx(EditorCanvasFTs, { appIntl: appIntl, currentPage: currentPage, raster: raster, templateSettings: templateSettings, templateBlocks: templateBlocks, contentPages: contentPages, updateParam: updateParam, updateInnerBlock: updateInnerBlock, updateBlock: updateBlock, updateCurrentPage: updateCurrentPage, pageFinder: pageFinder, pagePreview: pagePreview, insertContentBlock: insertContentBlock, changeBlock: changeContentBlock, removeContentBlock: removeContentBlock, resetBlock: resetContentBlock, copyBlock: copyContentBlock, copiedBlock: copiedBlock, pasteBlock: pasteContentBlock, resizeBlock: resizeContentBlock, pasteData: pasteData, errorsCount: errorsCount, errorsText: errorsText, filesUploading: filesUploading, imageUpload: uploadImage, usedMedia: usedMedia, blockContainer: blockContainer, setBlockContainer: selectBlockContainer, unsetBlockContainer: unselectBlockContainer, website: website, showTour: showTourF, setActiveHeight: setActiveHeight, navEntry: navEntry, resetNavEntry: resetNavEntry, init: templateSettings.initialized, pageWidths: pageWidths, pageHeights: pageHeights, topPaddings: topPaddings, rightPaddings: rightPaddings, bottomPaddings: bottomPaddings, leftPaddings: leftPaddings, publisherInfo: publisherInfo, rootUser: may('ROLE_ROOT_EMPLOYEE', user.roles), wlAdminUser: may('ROLE_WL_ADMIN', user.roles), isSubmission: edition === null || edition === void 0 ? void 0 : edition.is_submission, onlyWhitelabelAdminCanModifyBlocks: (_u = edition === null || edition === void 0 ? void 0 : edition.only_whitelabel_admin_can_modify_block_ids) !== null && _u !== void 0 ? _u : [], savingR: savingR, saveDescription: saveDescription, goToLastPageState: goToLastPageState, goToLastPage: goToLastPage, resetPageState: resetPageState, resetPage: resetPage, resetStates: resetStates, updateBlocksState: updateBlocksState, uploadError: uploadError, updateSpecialBlockAttributes: updateSpecialBlockAttributes, initDefaultPosition: initDefaultPosition, setSelectedColor: setSelectedColor, colorSettings: colorSettings, getColorSettings: getColorSettings, deleteSelectedColor: deleteSelectedColor, fontSizeSettings: fontSizeSettings, setFontSizeSettings: setFontSizeSettings, editionSettings: editionSettings, showSettingsF: showSettingsF })] }), deviceType === 'desktop' && (_jsxs(_Fragment, { children: [_jsx(Tooltip, { id: "left", place: "left" }), _jsx(Tooltip, { id: "right", place: "right" }), _jsx(Tooltip, { id: "top", place: "top" }), _jsx(Tooltip, { id: "editor-canvas-tooltip", place: "top", positionStrategy: "fixed" })] })), _jsx(Toaster, { richColors: true, style: { '--width': 'max-content' }, position: "bottom-left" })] })] }));
};
const mapDispatchToProps = (dispatch) => {
    return {
        doBlockForm: (id) => {
            dispatch(blockForm('editor', id));
        },
        doReleaseForm: (id) => {
            dispatch(releaseForm('editor', id));
        },
        doNotify: (code, text) => {
            dispatch(addNotification(code, text));
        },
    };
};
const mapStateToProps = (state) => {
    return {
        appIntl: state.intl,
        user: state.login.user,
        activeForms: state.activeForms,
        projectConfig: state.data.projectConfig,
    };
};
export default withRouter(legacyInjectIntl(connect(mapStateToProps, mapDispatchToProps)(EditorFTs)));
